
const data = {
  "categories": [
  {
    "title": "Proxmox VE Tools",
  }, {
    "title": "Home Assistant",
  }, {
    "title": "Automation",
  }, {
    "title": "MQTT",
  }, {
    "title": "Database",
  }, {
    "title": "Zigbee - Zwave",
  }, {
    "title": "Monitoring - Analytics",
  }, {
    "title": "Docker - Kubernetes",
  }, {
    "title": "Operating System",
  }, {
    "title": "Server - Networking",
  }, {
    "title": "Media - Photo",
  }, {
    "title": "Ad Blocker - DNS",
  }, {
    "title": "Document - Notes",
  }, {
    "title": "Dashboards",
  }, {
    "title": "File - Code",
  }, {
    "title": "Miscellaneous",
  }],
  "items": [
  {
    "category": "Proxmox VE Tools",
    "title": "Proxmox VE 7 Post Install",
    "content": `<p align="center"><img src="https://github.com/home-assistant/brands/blob/master/core_integrations/proxmoxve/icon.png?raw=true" height="100"/></p>
   
  <h1 align="center" id="heading"> Proxmox VE 7 Post Install </h1>
  
  This script provides options for managing Proxmox VE repositories, including disabling the Enterprise Repo, adding or correcting PVE7 sources, enabling the No-Subscription Repo, adding the test Repo, disabling the subscription nag, updating Proxmox VE, and rebooting the system.
    
  Run the command below in the <b>Proxmox VE Shell</b>. ⚠️ **PVE7 ONLY**
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/misc/post-pve-install.sh)"
  ~~~
  
  It is recommended to answer “yes” (y) to all options presented during the process.`
  },
  {
    "category": "Proxmox VE Tools",

    "title": "Proxmox VE Kernel Clean",
    "content": `<p align="center"><img src="https://github.com/home-assistant/brands/blob/master/core_integrations/proxmoxve/icon.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading">Proxmox VE Kernel Clean </h1>
  Cleaning unused kernel images is beneficial for reducing the length of the GRUB menu and freeing up disk space. By removing old, unused kernels, the system is able to conserve disk space and streamline the boot process.
      
  Run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/misc/kernel-clean.sh)"
  ~~~`
  },
  {
    "category": "Proxmox VE Tools",

    "title": "Proxmox VE Edge Kernel Tool",
    "content": `<p align="center"><img src="https://github.com/home-assistant/brands/blob/master/core_integrations/proxmoxve/icon.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading">Proxmox VE Edge Kernel Tool </h1>

  PVE [Edge Kernels](https://github.com/fabianishere/pve-edge-kernel) are custom Linux kernels specifically designed for Proxmox VE 7. Unlike regular LTS (Long-Term Support) kernels, PVE Edge Kernels aim to keep up with new kernel releases and provide the latest features and improvements. These kernels are tailored to the needs of Proxmox VE and are optimized for virtualization and container-based environments.

  
  Run the command below in the Proxmox VE Shell.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/misc/edge-kernel.sh)"
  ~~~`
  },
  {
    "category": "Proxmox VE Tools",

    "title": "Proxmox VE CPU Scaling Governor",
    "content": `<p align="center"><img src="https://github.com/tteck/Proxmox/blob/main/misc/images/cpu.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading">Proxmox VE CPU Scaling Governor </h1>

  The CPU scaling governor determines how the CPU frequency is adjusted based on the workload, with the goal of either conserving power or improving performance. By scaling the frequency up or down, the operating system can optimize the CPU usage and conserve energy when possible. [Generic Scaling Governors](https://www.kernel.org/doc/html/latest/admin-guide/pm/cpufreq.html?#generic-scaling-governors)
  
  Run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/misc/scaling-governor.sh)"
  ~~~`
  },
  {
    "category": "Proxmox VE Tools",

    "title": "Proxmox VE LXC Cleaner",
    "content": `<p align="center"><img src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Felpuig.xeill.net%2FMembers%2Fvcarceler%2Farticulos%2Fcontenedores-con-lxd-lxc%2Fcontainers.png&f=1&nofb=1" height="100"/></p>
  
  <h1 align="center" id="heading">Proxmox VE LXC Cleaner </h1>
  This script provides options to delete logs and cache, and repopulate apt lists for Ubuntu and Debian systems.
   
  Run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/misc/clean-lxcs.sh)"
  ~~~`
  },
  {
    "category": "Proxmox VE Tools",

    "title": "Proxmox VE LXC Updater",
    "content": `<p align="center"><img src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Felpuig.xeill.net%2FMembers%2Fvcarceler%2Farticulos%2Fcontenedores-con-lxd-lxc%2Fcontainers.png&f=1&nofb=1" height="100"/></p>
  
  <h1 align="center" id="heading">Proxmox VE LXC Updater </h1>
  This script is designed to easily and quickly update all LXC containers on a variety of Linux distributions, including Ubuntu, Debian, Devuan, Alpine Linux, CentOS-Rocky-Alma, Fedora, and ArchLinux. The script automatically skips templates during the update process, making it even more convenient to use.<br> 
  
  If there are other containers besides templates that need to be skipped during the update process, you can add them to the end of the command. This will ensure that these containers are also skipped.<br>
  example: <code class="highlighter-rouge">bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/misc/update-lxcs.sh)" -s 100 102 118</code>
  
  Run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/misc/update-lxcs.sh)"
  ~~~`
  },
  {
    "category": "Proxmox VE Tools",

    "title": "Proxmox VE Dark Theme",
    "content": `<p align="center"><img src="https://camo.githubusercontent.com/f6f33a09f8c1207dfb3dc1cbd754c2f3393562c11b1c999751ad9a91a656834a/68747470733a2f2f692e696d6775722e636f6d2f536e6c437948462e706e67" height="100"/></p>
  
  <h1 align="center" id="heading"> Proxmox VE Discord Dark Theme </h1>
  
  A dark theme for the Proxmox VE Web UI is a custom theme created by [Weilbyte](https://github.com/Weilbyte/PVEDiscordDark) that changes the look and feel of the Proxmox web-based interface to a dark color scheme. This theme can improve the visual experience and make the interface easier on the eyes, especially when used in low-light environments.
  
  Run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash <(curl -s https://raw.githubusercontent.com/Weilbyte/PVEDiscordDark/master/PVEDiscordDark.sh ) install
  ~~~
  
  To uninstall the theme, simply run the script with the <code class="highlighter-rouge">uninstall</code> command.`
  },
  {
    "category": "Proxmox VE Tools",

    "title": "Proxmox VE Backup Server Post Install",
    "content": `<p align="center"><img src="https://github.com/home-assistant/brands/blob/master/core_integrations/proxmoxve/icon.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Proxmox VE Backup Server Post Install </h1>
  The script will give options to Disable the Enterprise Repo, Add/Correct PBS Sources, Enable the No-Subscription Repo, Add Test Repo, Disable Subscription Nag, Update Proxmox Backup Server and Reboot PBS.
  
  Run the command below in the <b>Proxmox VE Shell</b>. ⚠️ **Proxmox VE Backup Server ONLY**
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/misc/post-pbs-install.sh)"
  ~~~
  
  It is recommended to answer “yes” (y) to all options presented during the process.`
  },
  {
    "category": "Home Assistant",

    "title": "Home Assistant OS VM",
    "content": `<p align="center"><img src="https://github.com/tteck/Proxmox/blob/main/misc/images/haos.png?raw=true"/></p>
   
  <h1 align="center" id="heading"> Home Assistant OS VM </h1>
  <h3 align="center"> Option to create VM using Stable, Beta or Dev Image </h3>
  
  This script automates the process of creating a Virtual Machine (VM) using the official KVM (qcow2) disk image provided by the Home Assistant Team. It involves finding, downloading, and extracting the image, defining user-defined settings, importing and attaching the disk, setting the boot order, and starting the VM. It supports various storage types, and does not involve any hidden installations.

  To create a new Proxmox VE Home Assistant OS VM, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/vm/haos-vm.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  4GB RAM - 32GB Storage - 2vCPU - Stable Image ⚡</h3>
  
  🛈 The disk must have a minimum size of 32GB and its size cannot be changed during the creation of the VM.

  After the script completes, click on the VM, then on the **_Summary_** tab to find the VM IP.
  
  **Home Assistant Interface: IP:8123**`
  },
  {
    "category": "Home Assistant",

    "title": "PiMox HAOS VM",
    "content": `<p align="center"><img src="https://github.com/tteck/Proxmox/blob/main/misc/images/pimox.png?raw=true" width="100" height="100"/></p>
  <h1 align="center" id="heading"> PiMox HAOS VM </h1>
  
  <h3 align="center"> Option to create VM using Stable, Beta or Dev Image </h3>
  
  The script automates the manual process of finding, downloading and extracting the aarch64 (qcow2) disk image provided by the Home Assistant Team, creating a VM with user defined settings, importing and attaching the disk, setting the boot order and starting the VM.
  
  To create a new PiMox HAOS VM, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/vm/pimox-haos-vm.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  4GB RAM - 32GB Storage - 2vCPU - Stable Image ⚡</h3>
  
  After the script completes, click on the VM, then on the **_Console_** tab to find the VM IP.
  
  **Home Assistant Interface: IP:8123**`
  },
  {
    "category": "Home Assistant",

    "title": "Home Assistant Container LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/docker/docs/main/assets/images/docker-icon.svg" height="100"/>
  <img src="https://avatars.githubusercontent.com/u/13844975?s=200&amp;v=4" width="100" height="100"/><img src="https://avatars1.githubusercontent.com/u/22225832?s=400&amp;v=4" alt="GitHub - portainer/portainer-docs: Portainer documentation" width="100" height="100"/></p>
    
  <h1 align="center" id="heading"> Home Assistant Container LXC </h1>
  <h3 align="center"> Option to Use Fuse Overlayfs (Advanced)</h3> 

  A standalone container-based installation of Home Assistant Core means that the software is installed inside a Docker container, separate from the host operating system. This allows for flexibility and scalability, as well as improved security, as the container can be easily moved or isolated from other processes on the host.
  
  🛈 *If the LXC is created Privileged, the script will automatically set up USB passthrough.*

  To create a new Proxmox VE Home Assistant Container LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update ALL Containers, Remove Unused Images or Install HACS, run the command below in the <b>LXC Console</b>.
    
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/homeassistant.sh)"
  ~~~
    
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 16GB Storage - 2vCPU ⚡</h3>
    
  **Home Assistant Interface: IP:8123**
    
  **Portainer Interface: IP:9000**
    
  ⚙️ **Path to HA /config**
  ~~~bash
  /var/lib/docker/volumes/hass_config/_data
  ~~~`
  
  },
  {
    "category": "Home Assistant",

    "title": "Home Assistant Core LXC",
    "content": `<p align="center"><img src="https://avatars.githubusercontent.com/u/13844975?s=200&amp;v=4" width="100" height="100"/></p>
  
  <h1 align="center" id="heading"> Home Assistant Core LXC </h1>
  
  A standalone installation of Home Assistant Core refers to a setup where the Home Assistant Core software is installed directly on a device or operating system, without the use of containers. This provides a simpler, but less flexible and scalable solution, as the software is tightly coupled with the underlying system.
  
  🛈 *If the LXC is created Privileged, the script will automatically set up USB passthrough.*
  
  To create a new Proxmox VE Home Assistant Core LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update, Install HACS or Filebrowser, run the command below in the <b>LXC Console</b>. <br>
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/homeassistant-core.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 8GB Storage - 2vCPU ⚡</h3>

  **Home Assistant Interface: IP:8123**
  
  ⚙️ **Path to HA /config**
  ~~~bash
  /root/.homeassistant
  ~~~`
  
  },
  {
    "category": "Home Assistant",

    "title": "Podman Home Assistant Container LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/podman.svg" height="100"/>
  <img src="https://avatars.githubusercontent.com/u/13844975?s=200&amp;v=4" height="100"/><img/></p>
  <h1 align="center" id="heading">Podman Home Assistant Container LXC</h1>
  
  A standalone Podman container-based installation of Home Assistant Core means that the Home Assistant Core software is installed inside a container managed by Podman, separate from the host operating system. This provides a flexible and scalable solution for running the software, as the container can be easily moved between host systems or isolated from other processes for security. Podman is a popular open-source tool for managing containers that is similar to Docker, but designed for use on Linux systems without a daemon.
  
  🛈 *If the LXC is created Privileged, the script will automatically set up USB passthrough.*

  To create a new Proxmox VE Podman Home Assistant Container LXC, run the command below in the <b>Proxmox VE Shell</b>. <br> 
  To Update Podman, Install HACS or FileBrowser, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/podman-homeassistant.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 16GB Storage - 2vCPU ⚡</h3>
    
  **Home Assistant Interface: IP:8123**
    
  ⚙️ **Path to HA /config**
  ~~~bash
  /var/lib/containers/storage/volumes/hass_config/_data
  ~~~`

  },
  {
    "category": "Automation",

    "title": "ioBroker LXC",
    "content": `<p align="center"><img src="https://github.com/ioBroker/ioBroker/blob/master/img/logos/ioBroker_Logo_256px.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> ioBroker LXC </h1>
    
  [ioBroker](https://www.iobroker.net/#en/intro) is an open-source platform for building and managing smart home automation systems. It provides a centralized control and management interface for connected devices, sensors, and other IoT devices. ioBroker integrates with a wide range of popular smart home systems, devices, and services, making it easy to automate tasks and processes, monitor and control devices, and collect and analyze data from a variety of sources. With its flexible architecture and easy-to-use interface, ioBroker is designed to make it simple for users to build and customize their own smart home automation systems, regardless of their technical background or experience.
  
  To create a new Proxmox VE ioBroker LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/iobroker.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
    
  **ioBroker Interface: IP:8081**`
  
  },
  {
    "category": "Automation",

    "title": "openHAB LXC",
    "content": `<p align="center"><img src="https://www.openhab.org/openhab-logo-square.png?raw=true" height="100"/></p>
  <h1 align="center" id="heading">openHAB LXC</h1>

  [openHAB](https://www.openhab.org/) is a popular open-source home automation platform that provides a vendor and technology agnostic solution for integrating and automating various smart home devices and services. It supports a wide range of devices and protocols, making it easy to bring together different systems and devices into a unified smart home ecosystem. With its user-friendly interface and powerful automation capabilities, openHAB makes it easy to create custom automations and monitor and control your smart home devices and systems, all from a single interface.
  
  To create a new Proxmox VE openHAB LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/openhab.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
    
  **openHAB Interface: IP:8080**`
  
  },
  {
    "category": "Automation",

    "title": "Homebridge LXC",
    "content": `<p align="center"><img src="https://homebridge.io/assets/images/logo.svg" height="100"/></p>
  <h1 align="center" id="heading">Homebridge LXC</h1>

  [Homebridge](https://homebridge.io/) is a popular open-source software platform that enables you to integrate smart home devices and services that do not natively support Apple's HomeKit protocol into the HomeKit ecosystem. This allows you to control and automate these devices using Siri, the Home app, or other HomeKit-enabled apps, making it easy to bring together a variety of different devices into a unified smart home system. With Homebridge, you can expand the capabilities of your smart home, unlocking new possibilities for automating and controlling your devices and systems.

  To create a new Proxmox VE Homebridge LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/homebridge.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 1vCPU ⚡</h3>
    
  **Homebridge Interface: IP:8581**
  
  ⚙️ **Initial Login**
  
  **username** <code class="highlighter-rouge">admin</code>
  
  **password** <code class="highlighter-rouge">admin</code>`
  
  },
  {
    "category": "Automation",

    "title": "ESPHome LXC",
    "content": `<p align="center"><img src="https://github.com/home-assistant/brands/blob/master/core_integrations/esphome/dark_icon@2x.png?raw=true" height="100"/></p>
  <h1 align="center" id="heading">ESPHome LXC</h1>
  
  [ESPHome](https://esphome.io/) is a platform for controlling ESP8266/ESP32-based devices using configuration files and integrating them with Home Automation systems. It provides a simple and flexible way to set up and manage the functionality of these devices, including defining and automating actions, monitoring sensors, and connecting to networks and other services. ESPHome is designed to be user-friendly and easy to use, and supports a wide range of features and integrations, making it a popular choice for home automation projects and IoT applications.

  To create a new Proxmox VE ESPHome LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update ESPHome, run the command below in the <b>LXC Console</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/esphome.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 2vCPU ⚡</h3>
    
  **ESPHome Interface: IP:6052**`
  
  },
  {
    "category": "Automation",

    "title": "Node-Red LXC",
    "content": `<p align="center"><img src="https://github.com/home-assistant/brands/blob/master/custom_integrations/nodered/icon.png?raw=true" height="100"/></p>
  <h1 align="center" id="heading">Node-Red LXC</h1>

  [Node-RED](https://nodered.org/) is a visual programming tool that allows developers and non-developers alike to easily wire together hardware devices, APIs, and online services to create custom applications. It provides a visual interface for building workflows, making it easy to create and modify complex integrations without having to write any code. Node-RED is used in a wide range of applications, from simple automations to complex integrations, and is known for its simplicity, versatility, and ease of use.

  To create a new Proxmox VE Node-RED LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Node-Red or Install Themes run the command below in the <b>LXC Console</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/node-red.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 1vCPU ⚡</h3>
    
  **Node-Red Interface: IP:1880**`
    
  },
  {
    "category": "Automation",

    "title": "n8n LXC",
    "content": `<p align="center"><img src="https://docs.n8n.io/_images/n8n-docs-icon.svg" height="70"/></p>
  <h1 align="center" id="heading">n8n LXC</h1>
    
  [n8n](https://n8n.io/) is a workflow automation tool that enables users to automate various tasks and processes by connecting various data sources, systems, and services. It provides a visual interface for building workflows, allowing users to easily define and automate complex sequences of actions, such as data processing, conditional branching, and API calls. n8n supports a wide range of integrations, making it a versatile tool for automating a variety of use cases, from simple data processing workflows to complex business processes. With its extendable architecture, n8n is designed to be easily customizable and can be adapted to meet the specific needs of different users and industries.
 
  To create a new Proxmox VE n8n LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update n8n, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/n8n.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 3GB Storage - 2vCPU ⚡</h3>
    
  **n8n Interface: IP:5678**`
  
  },
  {
    "category": "Automation",

    "title": "Scrypted LXC",
    "content": `<p align="center"><img src="https://www.scrypted.app/images/web_hi_res_512.png?raw=true" height="100"/></p>
  <h1 align="center" id="heading">Scrypted LXC</h1>

  <h3 align="center"> Option to add Coral Edge TPU support </h3> 
  
  [Scrypted](https://www.scrypted.app/) is a home automation platform that focuses on providing a seamless experience for managing and utilizing cameras in a smart home setup. It offers features like camera management, event triggering, video and image storage, and integration with other smart home devices and services. Scrypted is designed to make it easy to set up and use cameras in a home automation system, providing a simple and user-friendly interface for monitoring and automating camera-related tasks.

  🛈 *If the LXC is created Privileged, the script will automatically set up USB passthrough.*
  
  To create a new Proxmox VE Scrypted LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/scrypted.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
    
  **Scrypted Interface: (https)IP:10443**`
  
  },
  {
   "category": "MQTT",

   "title": "MQTT LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/eclipsemosquitto.svg" height="100"/></p>
  <h1 align="center" id="heading">MQTT LXC</h1>
  
  [Eclipse Mosquitto](https://mosquitto.org/) is an open-source message broker that implements the MQTT (Message Queuing Telemetry Transport) protocol. It is a lightweight and simple-to-use message broker that allows IoT devices and applications to communicate with each other by exchanging messages in real-time. Mosquitto is widely used in IoT applications, due to its low resource requirements and its compatibility with a wide range of devices and platforms
  
  To create a new Proxmox VE MQTT LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/mqtt.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>
    
  Mosquitto comes with a password file generating utility called mosquitto_passwd.
  ~~~bash
  sudo mosquitto_passwd -c /etc/mosquitto/passwd <usr>
  ~~~
  Password: < password >
  
  Create a configuration file for Mosquitto pointing to the password file we have just created.
  ~~~bash
  sudo nano /etc/mosquitto/conf.d/default.conf
  ~~~
  This will open an empty file. Paste the command below into it.
  ~~~bash
  allow_anonymous false
  persistence true
  password_file /etc/mosquitto/passwd
  listener 1883
  ~~~
  Save and exit the text editor with "Ctrl+O", "Enter" and "Ctrl+X".
  
  Now restart Mosquitto server.
  ~~~bash
  sudo systemctl restart mosquitto
  ~~~`
  
  },
  {
    "category": "MQTT",

    "title": "EMQX LXC",
    "content": `<p align="center"><img src="https://github.com/hassio-addons/repository/blob/master/emqx/icon.png?raw=true" height="100"/></p>
  <h1 align="center" id="heading">EMQX LXC</h1>

  [EMQX](https://www.emqx.io/) is an open-source MQTT broker that features a high-performance, real-time message processing engine. It is designed to handle large-scale IoT deployments, providing fast and reliable message delivery for connected devices. EMQX is known for its scalability, reliability, and low latency, making it a popular choice for IoT and M2M applications. It also offers a wide range of features and plugins for enhanced security, monitoring, and management.
  
  To create a new Proxmox VE EMQX LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
    bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/emqx.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  
  **EMQX Interface: IP:18083** 
    
  ⚙️ **Initial Login**
  
  **username** <code class="highlighter-rouge">admin</code>

  **password** <code class="highlighter-rouge">public</code>

  ⚙️ **Setup**
  
  Access Control ➡ Authentication  ➡ Create ➡ Next ➡ Next ➡ Create ➡ Users ➡ Add ➡ Username / Password (to authenicate with MQTT) ➡ Save. You're now ready to enjoy a high-performance MQTT Broker.`
  
  },
  {
    "category": "Database",

    "title": "Mariadb LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/mariadb.svg" height="100"/></p>
  <h1 align="center" id="heading">Mariadb LXC</h1>

  <h3 align="center"> Option to Install Adminer</h3>
  
  [MariaDB](https://mariadb.org/) is a fork of the popular MySQL database management system that is developed and maintained by the open-source community. It is also commercially supported, offering enterprise-level features and support for organizations that require them. MariaDB aims to maintain high compatibility with MySQL, ensuring a drop-in replacement capability.
  
  To create a new Proxmox VE Mariadb LXC, run the command below in the <b>Proxmox VE Shell</b>.
    
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/mariadb.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 1vCPU ⚡</h3>
    
  To enable MariaDB to listen to remote connections, you need to edit your defaults file. To do this, open the console in your MariaDB lxc:
  ~~~bash
  nano /etc/mysql/my.cnf
  ~~~
  Un-comment <code class="highlighter-rouge">port =3306</code>
  Save and exit the editor with "Ctrl+O", "Enter" and "Ctrl+X".
  
  ~~~bash
  nano /etc/mysql/mariadb.conf.d/50-server.cnf
  ~~~
  Comment <code class="highlighter-rouge">bind-address  = 127.0.0.1</code>
  Save and exit the editor with "Ctrl+O", "Enter" and "Ctrl+X".
  
  For new MariaDB installations, the next step is to run the included security script. This script changes some of the less secure default options. We will use it to block remote root logins and to remove unused database users.
  
  Run the security script:
  ~~~bash
  sudo mysql_secure_installation
  ~~~
  Enter current password for root (enter for none): <code class="highlighter-rouge">enter</code>
    
  Switch to unix_socket authentication [Y/n] <code class="highlighter-rouge">y</code> 
    
  Change the root password? [Y/n] <code class="highlighter-rouge">n</code> 
    
  Remove anonymous users? [Y/n] <code class="highlighter-rouge">y</code> 
    
  Disallow root login remotely? [Y/n] <code class="highlighter-rouge">y</code>  
    
  Remove test database and access to it? [Y/n] <code class="highlighter-rouge">y</code> 
    
  Reload privilege tables now? [Y/n] <code class="highlighter-rouge">y</code>  
  
  We will create a new account called admin with the same capabilities as the root account, but configured for password authentication. 
  ~~~bash
  sudo mysql
  ~~~ 
  Prompt will change to <code class="highlighter-rouge">MariaDB [(none)]></code>
  
  Create a new local admin (Change the username and password to match your preferences)
  ~~~sql
  CREATE USER 'admin'@'localhost' IDENTIFIED BY 'password';
  ~~~
  Give local admin root privileges (Change the username and password to match above)
  ~~~sql
  GRANT ALL ON *.* TO 'admin'@'localhost' IDENTIFIED BY 'password' WITH GRANT OPTION;
  ~~~
  
  Now, we'll give the user admin root privileges and password-based access that can connect from anywhere on your local area network (LAN), which has addresses in the subnet 192.168.100.0/24. This is an improvement because opening a MariaDB server up to the Internet and granting access to all hosts is bad practice.. Change the **_username_**, **_password_** and **_subnet_** to match your preferences:
  ~~~sql
  GRANT ALL ON *.* TO 'admin'@'192.168.100.%' IDENTIFIED BY 'password' WITH GRANT OPTION;
  ~~~
  Flush the privileges to ensure that they are saved and available in the current session:
  ~~~sql
  FLUSH PRIVILEGES;
  ~~~
  command below this, exit the MariaDB shell:
  ~~~bash
  exit
  ~~~
  Log in as the new database user you just created:
  ~~~bash
  mysql -u admin -p
  ~~~
  Create a new database:
  ~~~sql
  CREATE DATABASE homeassistant;
  ~~~
  command below this, exit the MariaDB shell:
  ~~~bash
  exit
  ~~~
  ⚠️ Reboot the lxc 
  
  Checking status.
  ~~~bash
  sudo systemctl status mariadb
  ~~~ 
  Change the recorder: <code class="highlighter-rouge">db_url:</code> in your HA configuration.yaml
    
  Example:
  ~~~bash
  recorder:
    db_url: mysql://admin:password@192.168.100.26:3306/homeassistant?charset=utf8mb4
  ~~~
    
  ⚙️ [**Adminer**](https://www.adminer.org/) is a full-featured database management tool
    
  **Adminer Interface: IP/adminer/**`
  },
  {
    "category": "Database",

    "title": "PostgreSQL LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/postgresql.svg" height="100"/></p>
  <h1 align="center" id="heading">PostgreSQL LXC</h1>
  <h3 align="center"> Option to Install Adminer</h3>
  
  [PostgreSQL](https://www.postgresql.org/) (often referred to as Postgres) is an open-source relational database management system that is known for its extensibility and strict adherence to SQL standards. It is a free and powerful database solution, suitable for a wide range of applications, from small projects to large enterprise systems. PostgreSQL is widely used for its reliability, feature-richness, and robustness.
  
  To create a new Proxmox VE PostgreSQL LXC, run the command below in the <b>Proxmox VE Shell</b>.
    
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/postgresql.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 1vCPU ⚡</h3>
  
  To make sure our PostgreSQL is secured with a strong password, set a password for its system user and then change the default database admin user account
  
  Change user password
  ~~~bash
  passwd postgres
  ~~~
  Login using Postgres system account
    
  ~~~bash
  su - postgres
  ~~~
  Now, change the Admin database password 
  ~~~bash
  psql -c "ALTER USER postgres WITH PASSWORD 'your-password';"
  ~~~
  Create a new user.
  ~~~bash
  psql
  ~~~
  ~~~sql
  CREATE USER admin WITH PASSWORD 'your-password';
  ~~~
  Create a new database:
  ~~~sql
  CREATE DATABASE homeassistant;
  ~~~
  Grant all rights or privileges on created database to the user
  ~~~sql
  GRANT ALL ON DATABASE homeassistant TO admin;
  ~~~
  To exit psql
  ~~~bash
  \\q
  ~~~ 
  Then type exit to get back to root
  
  Change the recorder: <code class="highlighter-rouge">db_url:</code> in your HA configuration.yaml
    
  Example:
  ~~~bash
  recorder:
    db_url: postgresql://admin:your-password@192.168.100.20:5432/homeassistant?client_encoding=utf8
  ~~~

  ⚙️ [**Adminer**](https://www.adminer.org/) is a full-featured database management tool
    
  **Adminer Interface: IP/adminer/**`
  },
  {
    "category": "Database",

    "title": "InfluxDB LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/influx.svg" height="100"/></p>
  <h1 align="center" id="heading">InfluxDB LXC</h1>
  <h3 align="center"> Options to Install InfluxDB v1 or v2 and Telegraf</h3>
  * Choosing InfluxDB v1 will result in Chronograf being installed automatically.
  
  [InfluxDB](https://www.influxdata.com/) is designed to handle high write and query loads, and is optimized for storing and analyzing time-stamped data, such as metrics, events, and logs. InfluxDB supports SQL-like query language and has a built-in HTTP API for data ingestion and retrieval. It's commonly used for IoT and industrial applications where time-series data is involved.
  
  [Telegraf](https://www.influxdata.com/time-series-platform/telegraf/) is a server agent that collects, processes, and aggregates metrics and events data from different sources, such as systems, databases, and APIs, and outputs the data to various outputs, such as InfluxDB, Prometheus, Elasticsearch, and many others.
  
  To create a new Proxmox VE InfluxDB LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
    bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/influxdb.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>

 InfluxDB V1 (Chronograf) Interface: IP:8888

 InfluxDB V2 Interface: IP:8086

 ⚙️ **InfluxDB Configuration**
  
  ~~~yaml
  nano /etc/influxdb/influxdb.conf
  ~~~
  
 ⚙️ **Telegraf Configuration**
  
  ~~~yaml
  nano /etc/telegraf/telegraf.conf
  ~~~`
  
  },
  {
    "category": "Zigbee - Zwave",

    "title": "Zigbee2MQTT LXC",
    "content": `<p align="center"><img src="https://github.com/Koenkk/zigbee2mqtt/blob/master/images/logo_bee_only.png?raw=true" height="100"/></p>
  <h1 align="center" id="heading">Zigbee2MQTT LXC</h1>

  <h3 align="center"> Option to switch to Edge/dev branch</h3>
  
  [Zigbee2MQTT](https://www.zigbee2mqtt.io/) is an open-source software project that allows you to use Zigbee-based smart home devices (such as those sold under the Philips Hue and Ikea Tradfri brands) with MQTT-based home automation systems, like Home Assistant, Node-RED, and others. The software acts as a bridge between your Zigbee devices and MQTT, allowing you to control and monitor these devices from your home automation system.
  
  🛈 *If the LXC is created Privileged, the script will automatically set up USB passthrough.*

  To create a new Proxmox VE Zigbee2MQTT LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Zigbee2MQTT, run the command below in the <b>LXC Console</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/zigbee2mqtt.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 2vCPU ⚡</h3>
 
  As an alternative option, you can use Alpine Linux and the Zigbee2MQTT package to create a Zigbee2MQTT LXC container with faster creation time and minimal system resource usage. <br>

  To create a new Proxmox VE Alpine-Zigbee2MQTT LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  ~~~bash
  bash -c "$(wget -qO - https://github.com/tteck/Proxmox/raw/main/ct/alpine-zigbee2mqtt.sh)"
  ~~~

  <h3 align="center" id="heading">⚡ Default Settings:  256MiB RAM - 300MiB Storage - 1vCPU ⚡</h3>

  ⚙️ **Determine the location of your adapter**
    
  ~~~bash
  ls -l /dev/serial/by-id
  ~~~
  Example Output: <code class="highlighter-rouge">lrwxrwxrwx 1 root root 13 Jun 19 17:30 usb-1a86_USB_Serial-if00-port0 -> ../../ttyUSB0</code>
  
  
  ⚙️ ⚠️ **Before you start Zigbee2MQTT you need to edit the [configuration.yaml](https://www.zigbee2mqtt.io/guide/configuration/)**

  Debian<br>
  ~~~bash
  nano /opt/zigbee2mqtt/data/configuration.yaml
  ~~~
  Alpine<br>
  ~~~bash
  nano /etc/zigbee2mqtt/configuration.yaml
  ~~~

  Save and exit the editor with “Ctrl+O”, “Enter” and “Ctrl+X”
  
  Example:
  ~~~yaml
  frontend:
    port: 9442
  homeassistant: true
  permit_join: false
  mqtt:
    base_topic: zigbee2mqtt
    server: 'mqtt://192.168.86.224:1883'
    user: usr
    password: pwd
    keepalive: 60
    reject_unauthorized: true
    version: 4
  serial:
    port: /dev/serial/by-id/usb-1a86_USB_Serial-if00-port0
    #adapter: deconz		#(uncomment for ConBee II)
  advanced:
    pan_id: GENERATE
    network_key: GENERATE
    channel: 20
  ~~~
  ⚙️ **Zigbee2MQTT can be started after completing the configuration**

  Debian<br>  
  ~~~bash
  cd /opt/zigbee2mqtt && npm start
  ~~~
  Alpine<br>  
  ~~~bash
  rc-update add zigbee2mqtt default
  ~~~`

  },
  {
    "category": "Zigbee - Zwave",

    "title": "deCONZ LXC",
    "content": `<p align="center"><img src="https://phoscon.de/img/phoscon-logo128x.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> deCONZ LXC </h1>
  
  [deCONZ](https://www.phoscon.de/en/conbee2/software#deconz) is a software for managing and controlling Zigbee-based smart home devices. It allows for setting up, configuring and visualizing the status of connected devices, as well as for triggering actions and automations. It works as a bridge between the Zigbee network and other home automation systems and can be used as a standalone solution or integrated into existing setups.
  
  🛈 *If the LXC is created Privileged, the script will automatically set up USB passthrough.*

  To create a new Proxmox VE deCONZ LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
    bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/deconz.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  **deCONZ Interface: IP:80**`
  
  },
  {
    "category": "Zigbee - Zwave",

    "title": "Z-Wave JS UI LXC",
    "content": `<p align="center"><img src="https://github.com/zwave-js/zwave-js-ui/blob/master/docs/_images/app_logo.svg?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Z-Wave JS UI LXC </h1>
  
  [Z-Wave JS UI](https://github.com/zwave-js/zwave-js-ui#) is an open-source software that serves as a gateway between Z-Wave devices and MQTT (Message Queuing Telemetry Transport) protocol, allowing users to control and monitor their Z-Wave devices via a user interface. The software provides a configurable platform to manage Z-Wave networks and integrate with other smart home systems through MQTT.
  
  🛈 *If the LXC is created Privileged, the script will automatically set up USB passthrough.*
  
  To create a new Proxmox VE Z-Wave JS UI LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Z-Wave JS UI, run the command below in the <b>LXC Console</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/zwave-js-ui.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  **Z-Wave JS UI Interface: IP:8091**`
  
  },
  {
    "category": "Monitoring - Analytics",

    "title": "Uptime Kuma LXC",
    "content": `<p align="center"><img src="https://github.com/louislam/uptime-kuma/blob/master/public/icon.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Uptime Kuma LXC </h1>
  
  [Uptime Kuma](https://github.com/louislam/uptime-kuma#uptime-kuma) is a monitoring and alerting system that tracks the availability and performance of servers, websites, and other internet-connected devices. It can be self-hosted and is open-source, offering a visually appealing interface for monitoring and receiving notifications about downtime events.
  
  To create a new Proxmox VE Uptime Kuma LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Uptime Kuma, run the command below in the <b>LXC Console</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/uptimekuma.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 2GB Storage - 1vCPU ⚡</h3>
  
  **Uptime Kuma Interface: IP:3001**`
  
  },
  {
    "category": "Monitoring - Analytics",
  
    "title": "Change Detection LXC",
    "content": `<p align="center"><img src="https://github.com/dgtlmoon/changedetection.io/blob/master/changedetectionio/static/images/avatar-256x256.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Change Detection LXC </h1>
  
  [Change Detection](https://changedetection.io/) is a service that allows you to monitor changes to web pages and receive notifications when changes occur. It can be used for a variety of purposes such as keeping track of online price changes, monitoring news websites for updates, or tracking changes to online forums.

  To create a new Proxmox VE Change Detection LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Change Detection, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/changedetection.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>
  
  **Change Detection Interface: IP:5000**`
  
  
  },
  {
    "category": "Monitoring - Analytics",

    "title": "Prometheus LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/prometheus.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> Prometheus LXC </h1>
  
  [Prometheus](https://prometheus.io/) is widely used to monitor the performance and health of various infrastructure components and applications, and trigger alerts based on predefined rules. It has a multi-dimensional data model and supports various data sources and exporters, making it an extremely flexible and scalable monitoring solution.
  
  To create a new Proxmox VE Prometheus LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/prometheus.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 4GB Storage - 1vCPU ⚡</h3>
  
  **Prometheus Interface: IP:9090**`
  
  },
  {
    "category": "Monitoring - Analytics",

    "title": "Grafana LXC",
    "content": `<p align="center"><img src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fdocs.checkmk.com%2Flatest%2Fimages%2Fgrafana_logo.png&f=1&nofb=1" height="100"/></p>
  
  <h1 align="center" id="heading"> Grafana LXC </h1>
  
  [Grafana](https://grafana.com/) is a data visualization and monitoring platform that enables users to query, visualize, alert on and understand metrics, logs, and other data sources. It integrates with various data sources, including Prometheus, InfluxDB, Elasticsearch, and many others, to present a unified view of the data and enable users to create insightful and interactive dashboards.
  
  To create a new Proxmox VE Grafana LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/grafana.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>
 
  As an alternative option, you can use Alpine Linux and the Grafana package to create a Grafana LXC container with faster creation time and minimal system resource usage. <br>
  
  To create a new Proxmox VE Alpine-Grafana LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  ~~~bash
  bash -c "$(wget -qO - https://github.com/tteck/Proxmox/raw/main/ct/alpine-grafana.sh)"
  ~~~

  <h3 align="center" id="heading">⚡ Default Settings:  256Mib RAM - 500MiB Storage - 1vCPU ⚡</h3>

  **Grafana Interface: IP:3000**
  
  ⚙️ **Initial Login**
  
  **username** <code class="highlighter-rouge">admin</code>
  
  **password** <code class="highlighter-rouge">admin</code>`
  
  },
  {
    "category": "Docker - Kubernetes",

    "title": "Docker LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/docker.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> Docker LXC </h1>
  <h3 align="center"> Options to Install Portainer and/or Docker Compose V2 (Fuse Overlayfs is in "Advanced")</h3>
  
  [Docker](https://www.docker.com/) is an open-source project for automating the deployment of applications as portable, self-sufficient containers.
  
  🛈 *If the LXC is created Privileged, the script will automatically set up USB passthrough.*

  To create a new Proxmox VE Docker LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/docker.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  As an alternative option, you can use Alpine Linux and the Docker package to create a Docker LXC container with faster creation time and minimal system resource usage. <br>
  
  To create a new Proxmox VE Alpine-Docker LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  ~~~bash
  bash -c "$(wget -qO - https://github.com/tteck/Proxmox/raw/main/ct/alpine-docker.sh)"
  ~~~

  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 2GB Storage - 1vCPU ⚡</h3>

  **⚠ Run Compose V2 by replacing the hyphen (-) with a space, using docker compose, instead of docker-compose.**
  
  **Portainer Interface: IP:9000**`

  },
  {
    "category": "Docker - Kubernetes",

    "title": "Umbrel LXC",
  
    "content": `<p align="center"><img src="https://uploads-ssl.webflow.com/62966b49981ba146f4842f45/62966b49981ba15b44842fe4_umbrel-logo-compact-purple.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> Umbrel LXC </h1>
  
  [Umbrel](https://umbrel.com/) is an open-source project that provides a secure and easy-to-use software solution for hosting your own personal server, enabling you to have full control over your data and online services. The OS provides a comprehensive web interface and pre-configured applications for various tasks, making self-hosting accessible for non-technical users.
  
  🛈 *If the LXC is created Privileged, the script will automatically set up USB passthrough.*

  To create a new Proxmox VE Umbrel LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/umbrel.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
  
  **Umbrel Interface: IP** (a reboot is required before app installs)`
  
  },
  {
    "category": "Docker - Kubernetes",

    "title": "CasaOS LXC",
  
    "content": `<p align="center"><img src="https://www.casaos.io/images/casa_9c491a0f.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> CasaOS LXC </h1>
  
  [CasaOS](https://www.casaos.io/) is a software that aims to make it easy for users to create a personal cloud system at home. It uses the Docker ecosystem to provide a simple, user-friendly experience for managing various applications and services.
  
  🛈 *If the LXC is created Privileged, the script will automatically set up USB passthrough.*

  To create a new Proxmox VE CasaOS LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/casaos.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
  
  **CasaOS Interface: IP**`
  
  },
  {
    "category": "Docker - Kubernetes",

    "title": "k0s Kubernetes LXC",
  
    "content": `<p align="center"><img src="https://k0sproject.io/images/k0s-logo.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> k0s Kubernetes LXC </h1>
  <h3 align="center"> Option to Install Helm Package Manager</h3>
  
  [k0s](https://k0sproject.io/) is a lightweight, easy-to-deploy, and certified Kubernetes distribution designed to simplify the process of deploying and managing a Kubernetes cluster. It focuses on simplicity and ease-of-use while providing a secure and production-ready environment for running applications.
  
  
  To create a new Proxmox VE k0s Kubernetes LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/k0s.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 4GB Storage - 2vCPU ⚡</h3>

  ⚙️ **Config Path**

  ~~~yaml
  /etc/k0s/k0s.yaml
  ~~~`
  
  },
  {
    "category": "Docker - Kubernetes",

    "title": "Podman LXC",
  
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/podman.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> Podman LXC </h1>
  
  [Podman](https://podman.io/) is an open-source, daemonless, and portable container engine that allows users to manage containers on Linux systems without the need for a daemon or system service to be running in the background. It provides an API and a command-line interface that can be used to create, run, and manage containers and their associated networks, volumes, and images. It is built on top of the Open Container Initiative (OCI) runtime specification, making it compatible with other OCI-compliant container engines.
  
  
  To create a new Proxmox VE Podman LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/podman.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 4GB Storage - 2vCPU ⚡</h3>`
    
  },
  {
    "category": "Operating System",

    "title": "Debian LXC",
    "content": `<p align="center"><img src="https://www.debian.org/Pics/debian-logo-1024x576.png" height="100"/></p>
  
  <h1 align="center" id="heading"> Debian LXC </h1>
  Debian Linux is a distribution that emphasizes free software. It supports many hardware platforms.

  To create a new Proxmox VE Debian LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/debian.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>`
  
  },
  {
    "category": "Operating System",

    "title": "Ubuntu LXC",
    "content": `<p align="center"><img src="https://assets.ubuntu.com/v1/29985a98-ubuntu-logo32.png" height="100"/></p>
  
  <h1 align="center" id="heading"> Ubuntu LXC </h1>
  <h3 align="center" id="heading"> Option to select version 20.04, 22.04 or 22.10</h3>
  Ubuntu is a distribution based on Debian, designed to have regular releases and a consistent user experience.
  
  To create a new Proxmox VE Ubuntu LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/ubuntu.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU - 22.04 ⚡</h3>`
  
  },
  {
    "category": "Operating System",

    "title": "Alpine LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/alpinelinux.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> Alpine LXC </h1>
  A security-oriented, lightweight Linux distribution based on musl and BusyBox.<br>
  By default, the root password is set to <code class="highlighter-rouge">alpine</code>. If you choose to use advanced settings, you will need to define a password, autologin is currently unavailable.

  To create a new Proxmox VE Alpine LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/alpine.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 100MiB Storage - 1vCPU ⚡</h3>

  ⚙️ **Default Password** <code class="highlighter-rouge">alpine</code>

  ⚙️ **To Update Alpine**
  
  ~~~bash
  apk update && apk upgrade
  ~~~`
  },
  {
    "category": "Operating System",

    "title": "Arch LXC",
    "content": `<p align="center"><img src="https://gitlab.archlinux.org/uploads/-/system/appearance/header_logo/1/lol2.png
    " alt="Arch" height="100"/></p>
  
  <h1 align="center" id="heading"> Arch Linux LXC </h1>
  Arch Linux is an independently developed, x86-64 general-purpose Linux distribution that strives to provide the latest stable versions of most software by command below a rolling-release model. The default installation is a minimal base system, configured by the user to only add what is purposely required.
  
  To create a new Proxmox VE Arch Linux LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/archlinux.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 1GB Storage - 1vCPU ⚡</h3>


  ⚙️ **Default Password** <code class="highlighter-rouge">archlinux</code>
  
  ⚙️ **To get updated:**

  <code class="highlighter-rouge">pacman-key --init</code>

  <code class="highlighter-rouge">pacman-key --populate archlinux</code>

  <code class="highlighter-rouge">pacman -Sy archlinux-keyring && pacman -Su</code>`
  },
  {
    "category": "Operating System",

    "title": "Devuan LXC",
    "content": `<p align="center"><img src="https://avatars.githubusercontent.com/u/9929258?s=200&v=4?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Devuan LXC </h1>

  [Devuan](https://www.devuan.org/) is a free and open-source operating system based on Debian, but without the systemd init system. It aims to provide users with a reliable and stable Debian-based system that retains traditional init systems, giving users control over their system and avoiding the controversies surrounding the adoption of systemd.

  To create a new Proxmox VE Devuan LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/devuan.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 1GB Storage - 1vCPU ⚡</h3>

  ⚙️ **Default Password** <code class="highlighter-rouge">devuan</code>`

  },
  {
    "category": "Operating System",

    "title": "Rocky Linux LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/rockylinux.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> Rocky Linux LXC </h1>

  [Rocky Linux](https://rockylinux.org/) is a community-driven Linux distribution that aims to provide a free and open-source operating system that is fully compatible with Red Hat Enterprise Linux (RHEL). Rocky Linux aims to provide a stable and predictable platform for enterprise users, while also incorporating modern features and tools.

  To create a new Proxmox VE Rocky Linux LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/rockylinux.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 1GB Storage - 1vCPU ⚡</h3>

  ⚙️ **Default Password** <code class="highlighter-rouge">rockylinux</code>

  ⚙️ **To Update Rocky Linux**
  
  ~~~bash
  dnf -y update && dnf -y upgrade
  ~~~`
  },
  {
    "category": "Server - Networking",

    "title": "Cloudflared LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/cloudflare.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> Cloudflared LXC </h1>
   
  [Cloudflared](https://www.cloudflare.com/) is a command-line tool that allows you to securely access resources on the Cloudflare network, such as websites and APIs, from your local computer. It works by creating a secure tunnel between your computer and the Cloudflare network, allowing you to access resources as if they were on your local network. 
  
  To create a new Proxmox VE Cloudflared LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/cloudflared.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>`
  
  },
  {
    "category": "Server - Networking",

    "title": "Nginx Proxy Manager LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/nginxproxymanager.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> Nginx Proxy Manager LXC </h1>
  
  [Nginx Proxy Manager](https://nginxproxymanager.com/) is a tool that provides a web-based interface to manage Nginx reverse proxies. It enables users to easily and securely expose their services to the internet by providing features such as HTTPS encryption, domain mapping, and access control. It eliminates the need for manual configuration of Nginx reverse proxies, making it easy for users to quickly and securely expose their services to the public.
  
  To create a new Proxmox VE Nginx Proxy Manager LXC Container, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Nginx Proxy Manager, run the command below in the <b>LXC Console</b>.
  ~~~yaml
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/nginxproxymanager.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 3GB Storage - 1vCPU ⚡</h3>
  
  Forward port <code class="highlighter-rouge">80</code> and <code class="highlighter-rouge">443</code> from your router to your Nginx Proxy Manager LXC IP.
  
  Add the command below to your <code class="highlighter-rouge">configuration.yaml</code> in Home Assistant.
  ~~~yaml
  http:
    use_x_forwarded_for: true
    trusted_proxies:
    - 192.168.100.27 ###(Nginx Proxy Manager LXC IP)###
  ~~~
  
  **Nginx Proxy Manager Interface: IP:81**
  
  ⚙️ **Initial Login**
  
  **username** <code class="highlighter-rouge">admin@example.com</code>
  
  **password** <code class="highlighter-rouge">changeme</code>`

  },
  {
    "category": "Server - Networking",

    "title": "YunoHost LXC",
    "content": `<p align="center"><img src="https://yunohost.org/_images/ynh_logo_white_300dpi.png" height="100"/></p>
  
  <h1 align="center" id="heading"> YunoHost LXC </h1>
   
  [YunoHost](https://yunohost.org/#/) is an operating system aiming for the simplest administration of a server, and therefore democratize self-hosting, while making sure it stays reliable, secure, ethical and lightweight. 
  
  To create a new Proxmox VE YunoHost LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/yunohost.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 20GB Storage - 2vCPU ⚡</h3>
  
  **YunoHost Interface: IP/**`
  
  },
  {
    "category": "Server - Networking",

    "title": "UniFi Network Application LXC",
    "content": `<p align="center"><img src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fblog.ui.com%2Fwp-content%2Fuploads%2F2016%2F10%2Funifi-app-logo-300x108.png&f=1&nofb=1" height="100"/></p>
  
  <h1 align="center" id="heading"> UniFi Network Application LXC </h1>
  
  <h3 align="center"> With Local Controller Option </h3>
  
  UniFi Network Application is a software that helps manage and monitor UniFi networks (Wi-Fi, Ethernet, etc.) by providing an intuitive user interface and advanced features. It allows network administrators to configure, monitor, and upgrade network devices, as well as view network statistics, client devices, and historical events. The aim of the application is to make the management of UniFi networks easier and more efficient.
  
  To create a new Proxmox VE UniFi Network Application LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Unifi Network Application, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/unifi.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
  
  **UniFi Interface: (https)IP:8443**`
  
  },
  {
    "category": "Server - Networking",

    "title": "Omada Controller LXC",
    "content": `<p align="center"><img src="https://www.enterpriseitpro.net/wp-content/uploads/2020/12/logo-omada.png" height="100"/></p>
  
  <h1 align="center" id="heading"> Omada Controller LXC </h1>
  
  Omada Controller is a software application used to manage TP-Link's Omada EAP (Enterprise Access Point) devices. It allows administrators to centrally manage a large number of EAPs, monitor network performance, and control user access to the network. The software provides an intuitive interface for network configuration, firmware upgrades, and network monitoring. By using the Omada Controller, administrators can streamline the management process, reduce manual intervention, and improve the overall security and reliability of the network.
  
  To create a new Proxmox VE Omada Controller LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/omada.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
  
  **Omada Interface: (https)IP:8043**`
  
  },
  {
    "category": "Server - Networking",

    "title": "WireGuard LXC",
  
    "content": `<p align="center"><img src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn.icon-icons.com%2Ficons2%2F2699%2FPNG%2F512%2Fwireguard_logo_icon_168760.png&f=1&nofb=1" height="100"/></p>
  
  <h1 align="center" id="heading"> WireGuard LXC </h1>
   
  WireGuard is a free and open-source virtual private network (VPN) software that uses modern cryptography to secure the data transmitted over a network. It is designed to be fast, secure, and easy to use. WireGuard supports various operating systems, including Linux, Windows, macOS, Android, and iOS. It operates at the network layer and is capable of being used with a wide range of protocols and configurations. Unlike other VPN protocols, WireGuard is designed to be simple and fast, with a focus on security and speed. It is known for its ease of setup and configuration, making it a popular choice for personal and commercial use.

  To create a new Proxmox VE WireGuard LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update WireGuard or Install a Dashboard, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/wireguard.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>
  
  ⚙️ **Host Configuration**
  
  ~~~yaml
  nano /etc/pivpn/wireguard/setupVars.conf
  ~~~
  ⚙️ **Add Clients** 
  
  ~~~yaml
  pivpn add
  ~~~`

  },
  {
    "category": "Server - Networking",

    "title": "Cronicle Primary LXC",
    "content": `<p align="center"><img src="https://github.com/jhuckaby/Cronicle/blob/master/htdocs/images/logo-128.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Cronicle Primary LXC </h1>
  
  [Cronicle](https://github.com/jhuckaby/Cronicle) is a task scheduling and management software that allows users to schedule and run tasks automatically on multiple servers. It has a web-based user interface that provides a convenient and centralized way to manage tasks and view their execution status. With Cronicle, users can schedule tasks to run at specific times, or on demand, and assign tasks to specific worker servers. The software provides real-time statistics and a live log viewer to help users monitor the progress of tasks. Cronicle is designed for use in large-scale environments, making it a valuable tool for automation and management of complex and time-sensitive tasks.

  To create a new Proxmox VE Cronicle Primary LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Cronicle or Install Cronicle Worker, run the command below in a <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/cronicle.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>
  
  **Cronicle Primary Interface: IP:3012**

  ⚙️ Config Path
  ~~~bash
  /opt/cronicle/conf/config.json
  ~~~

  Primary and Worker Private Keys Must Match.`
  
  },
  {
    "category": "Server - Networking",

    "title": "MeshCentral LXC",
    "content": `<p align="center"><img src="https://github.com/Ylianst/MeshCentral/blob/master/public/favicon-303x303.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> MeshCentral LXC </h1>
  
  [MeshCentral](https://meshcentral.com/info/) is a web-based computer management platform that provides remote control and management capabilities for computers. It allows administrators to manage and control computers over a local network or the internet through a single, centralized web-based interface. With MeshCentral, users can monitor the status of computers, perform remote administration tasks, and control the power state of machines. The software supports various operating systems and provides real-time updates and alerts to keep administrators informed of the status of their systems. MeshCentral is designed to provide an easy-to-use, scalable, and secure solution for remote computer management, making it a valuable tool for IT administrators, helpdesk support, and remote workers.
  
  To create a new Proxmox VE MeshCentral LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/meshcentral.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>
  
  **MeshCentral Interface: IP**`
  
  },
  {
    "category": "Server - Networking",

    "title": "Tailscale",
    "content": `<p align="center"><img src="https://avatars.githubusercontent.com/u/48932923?v=4&s=100"/></p>
  
  <h1 align="center" id="heading"> Tailscale</h1>
  
  [Tailscale](https://tailscale.com/) is a software-defined networking solution that enables secure communication between devices over the internet. It creates a virtual private network (VPN) that enables devices to communicate with each other as if they were on the same local network. Tailscale works even when the devices are separated by firewalls or subnets, and provides secure and encrypted communication between devices. With Tailscale, users can connect devices, servers, computers, and cloud instances to create a secure network, making it easier to manage and control access to resources. Tailscale is designed to be easy to set up and use, providing a streamlined solution for secure communication between devices over the internet.
  
  To Install Talescale on an existing LXC, run the command below in the <b>Proxmox VE Shell</b> (replace <code class="highlighter-rouge">106</code> with your LXC ID).
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/misc/add-tailscale-lxc.sh)" -s 106
  ~~~
  After the script finishes, reboot the LXC then run <code class="highlighter-rouge">tailscale up</code> in the LXC console
  
  [**Tailscale Login**](https://login.tailscale.com/start)`
  
  },
  {
    "category": "Server - Networking",

    "title": "CrowdSec",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/crowdsecurity/crowdsec-docs/main/crowdsec-docs/static/img/crowdsec_no_txt.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> CrowdSec</h1>

  [CrowdSec](https://crowdsec.net/) is a free and open-source intrusion prevention system (IPS) designed to provide network security against malicious traffic. It is a collaborative IPS that analyzes behaviors and responses to attacks by sharing signals across a community of users. CrowdSec leverages the collective intelligence of its users to detect and respond to security threats in real-time. With CrowdSec, network administrators can set up protection against a wide range of threats, including malicious traffic, bots, and denial-of-service (DoS) attacks. The software is designed to be easy to use and integrate with existing security systems, making it a valuable tool for enhancing the security of any network.
  
  To Install CrowdSec, ⚠️ run the command below in the <b>LXC console</b>.
  
  ~~~bash
    bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/misc/crowdsec.sh)"
  ~~~
  
  [**Control center for your CrowdSec machines.**](https://app.crowdsec.net/product-tour)`
  },
  {
    "category": "Server - Networking",

    "title": "Keycloak LXC",
    "content": `<p align="center"><img src="https://www.keycloak.org/resources/images/keycloak_icon_512px.svg?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Keycloak LXC</h1>

  [Keycloak](https://www.keycloak.org/) is an open-source identity and access management solution that provides centralized authentication and authorization for modern applications and services. It enables organizations to secure their applications and services with a single sign-on (SSO) solution, reducing the need for users to remember multiple login credentials. Keycloak supports various authentication protocols, including SAML, OAuth, and OpenID Connect, and integrates with a wide range of applications and services. With Keycloak, administrators can manage user identities, define security policies, and monitor access to their applications and services. The software is designed to be scalable, flexible, and easy to use, making it a valuable tool for enhancing the security and usability of modern applications and services.
  
  To create a new Proxmox VE Keycloak LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/keycloak.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 4GB Storage - 2CPU ⚡</h3>

  **Keycloak Interface: IP:8080** (First start can take a few minutes)
  
  ⚙️ **Initial Login**
  
  The initial admin user can be added manually using the web frontend when accessed from localhost or automatically using environment variables.
  
  To add the initial admin user using environment variables, set <code class="highlighter-rouge">KEYCLOAK_ADMIN</code> for the initial admin username and <code class="highlighter-rouge">KEYCLOAK_ADMIN_PASSWORD</code> for the initial admin password.
  
  First, stop Keycloak
  ~~~bash
  systemctl stop keycloak.service
  ~~~
  then start Keycloak by coping & pasting the command below (only needed once)
  ~~~bash
  cd /opt/keycloak
  export KEYCLOAK_ADMIN=admin
  export KEYCLOAK_ADMIN_PASSWORD=changeme
  bin/kc.sh start-dev 
  ~~~`
  },
  {
    "category": "Server - Networking",

    "title": "Mikrotik RouterOS VM",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/mikrotik.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> Mikrotik RouterOS VM </h1>
  
  [Mikrotik RouterOS](https://wiki.mikrotik.com/wiki/Manual:TOC) is a Linux-based operating system that transforms a computer into a router. It provides a wide range of features for network routing, firewall, bandwidth management, wireless access point, backhaul link, hotspot gateway, VPN server, and many others. RouterOS is a versatile solution that supports various network configurations, including those with multiple WAN links, hotspots, and VPNs. It is highly customizable, allowing administrators to configure and manage their networks according to their specific requirements. With RouterOS, network administrators can monitor and control the performance and security of their networks, ensuring reliable and secure communication for their users. The software is designed to be easy to use and provides a wide range of tools for network management, making it a valuable solution for small and large networks alike.
  
  To create a new Proxmox VE Mikrotik RouterOS VM, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/vm/mikrotik-routeros.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 2GB Storage - 1CPU ⚡</h3>

  Setup is done via VM console.

  ⚙️ **Initial Login**

  **username** <code class="highlighter-rouge">admin</code>
  
  **password** <code class="highlighter-rouge">no password</code>`
  },
  {
    "category": "Media - Photo",

    "title": "Audiobookshelf LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/audiobookshelf.svg" height="100"/></p>
  
  <h1 align="center" id="heading">Audiobookshelf LXC </h1>
  
  [Audiobookshelf](https://www.audiobookshelf.org/) is a Self-hosted audiobook and podcast server.

  To create a new Proxmox VE Audiobookshelf LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/audiobookshelf.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  **Audiobookshelf Interface: IP:13378**`
  },
  {
    "category": "Media - Photo",

    "title": "Plex Media Server LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/plex-white.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> Plex Media Server LXC </h1>
  <h3 align="center" id="heading"> With Hardware Acceleration Support </h3> 
  
  To create a new Proxmox VE Plex Media Server LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Plex Media Server, run the command below in the <b>LXC Console</b>.

  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/plex.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
  
  **Plex Media Server Interface: IP:32400/web**`
  
  },
  {
    "category": "Media - Photo",

    "title": "Emby Media Server LXC",
    "content": `<p align="center"><img src="https://github.com/home-assistant/brands/blob/master/core_integrations/emby/icon.png?raw=true" height="100"/></p>
  <h1 align="center" id="heading"> Emby Media Server LXC </h1>
  
  [Emby](https://emby.media/) brings together your personal videos, music, photos, and live television.
  
  To create a new Proxmox VE Emby Media Server LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Emby, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/emby.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
  
  **Emby Media Server Interface: IP:8096**`
  
  },
  {
    "category": "Media - Photo",

    "title": "Jellyfin Media Server LXC",
    "content": `<p align="center"><img src="https://github.com/home-assistant/brands/blob/master/core_integrations/jellyfin/icon.png?raw=true" height="100"/></p>
  <h1 align="center" id="heading"> Jellyfin Media Server LXC </h1>
  
  [TurnKey has a LXC CT for Jellyfin](https://www.turnkeylinux.org/mediaserver)
  
  To create a new Proxmox VE Jellyfin Media Server LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
    bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/jellyfin.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
  
  **Jellyfin Media Server Interface: IP:8096**
  
  FFmpeg path: <code class="highlighter-rouge">/usr/lib/jellyfin-ffmpeg/ffmpeg</code>`
  
  },
  {
    "category": "Media - Photo",

    "title": "NextCloudPi LXC",
    "content": `<p align="center"><img src="https://github.com/nextcloud/nextcloudpi/blob/master/ncp-app/img/app.svg?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading">NextCloudPi LXC </h1>
  
  [NextCloudPi](https://github.com/nextcloud/nextcloudpi#features) is a popular self-hosted solution for file collaboration and data storage. It is built on the NextCloud software, which is an open-source platform for data management. NextCloudPi provides a simple and efficient way to set up a private cloud server, allowing users to store and share their data securely. With NextCloudPi, users can access their files and data from anywhere and collaborate with others, making it a valuable solution for personal and business use. The software supports various platforms, including desktop, mobile, and web, providing a seamless and unified experience for users. NextCloudPi is designed to be easy to set up and use, making it a popular choice for those who want to host their own data and collaborate with others in a secure and private environment.
  
  To create a new Proxmox VE NextCloudPi LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/nextcloudpi.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
  
  **NextCloudPi Interface: (https)IP/**`
  },
  {
    "category": "Media - Photo",

    "title": "OpenMediaVault LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/loganmarchione/homelab-svg-assets/main/assets/openmediavault.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> OpenMediaVault LXC </h1>
  
  [OpenMediaVault](https://www.openmediavault.org/) is a next-generation network-attached storage (NAS) solution based on Debian Linux. It provides a web-based interface for managing and storing digital data, making it easy to use and set up. OpenMediaVault supports various storage protocols, including SMB/CIFS, NFS, and FTP, and provides a wide range of features for data management, such as user and group management, disk quotas, and data backup and recovery. The software is designed to be flexible and scalable, making it a valuable solution for both personal and enterprise use. OpenMediaVault provides a stable and reliable platform for managing and storing digital data, making it a popular choice for those who want to host their own data and ensure its security and privacy. With OpenMediaVault, users can access their data from anywhere and easily share it with others, making it a valuable tool for collaboration and data management.
  
  To create a new Proxmox VE OpenMediaVault LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/omv.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  **OpenMediaVault Interface: IP**
  
  ⚙️ **Initial Login**
  
  **username** <code class="highlighter-rouge">admin</code>
  
  **password** <code class="highlighter-rouge">openmediavault</code>`
  },
  {
    "category": "Media - Photo",

    "title": "Navidrome LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/navidrome/navidrome/master/resources/logo-192x192.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Navidrome LXC </h1>
  
  [Navidrome](https://www.navidrome.org/) is a music server solution that makes your music collection accessible from anywhere. It provides a modern web-based user interface and compatibility with a range of third-party mobile apps for both iOS and Android devices. With Navidrome, users can access their music collection from anywhere, whether at home or on the go. The software supports a variety of music formats, making it easy for users to play their favorite songs and albums. Navidrome provides a simple and user-friendly interface for managing and organizing music collections, making it a valuable tool for music lovers who want to access their music from anywhere. The software is designed to be easy to set up and use, making it a popular choice for those who want to host their own music server and enjoy their music collection from anywhere.
  
  To create a new Proxmox VE Navidrome LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Navidrome, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/navidrome.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  To change Navidrome music folder path, edit: <code class="highlighter-rouge">/var/lib/navidrome/navidrome.toml</code>
  
  **Navidrome Interface: IP:4533**`
  
  },
  {
    "category": "Media - Photo",

    "title": "PhotoPrism LXC",
    "content": `<p align="center"><img src="https://github.com/tteck/Proxmox/blob/main/misc/images/photoprism.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> PhotoPrism LXC </h1>
  
  [PhotoPrism](https://photoprism.app/) is a photo management app that uses artificial intelligence to help users browse, organize, and share their photo collection. It provides a user-friendly interface for managing large photo collections, making it easy to find and view images. PhotoPrism uses AI algorithms to automatically categorize and tag images, making it easier for users to search and find the photos they want. The app supports a wide range of image formats and provides features such as geotagging, image editing, and metadata management. PhotoPrism is designed to be easy to use and provides a seamless experience for managing and sharing photos, making it a valuable tool for personal and professional use. The software is also highly customizable, allowing users to personalize the app to fit their needs. With PhotoPrism, users can easily access, organize, and share their photos from anywhere, making it a powerful tool for managing and sharing photo collections.
  
  To create a new Proxmox VE PhotoPrism LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update PhotoPrism, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/photoprism.sh)"
  ~~~
  The script builds from source, which takes time and resources. After the build, the script will automatically set resources to Normal Settings.
  <h3 align="center" id="heading">⚡ Build Settings:  4GB RAM - 8GB Storage - 4vCPU ⚡</h3>
  <h3 align="center" id="heading">⚡ Normal Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
  
  **PhotoPrism Interface: IP:2342**
  
  ⚙️ **Initial Login**
  
  **username** <code class="highlighter-rouge">admin</code>
  
  **password** <code class="highlighter-rouge">changeme</code>
  
  [PhotoSync](https://www.photosync-app.com/home.html)`
  
  },
  {
    "category": "Media - Photo",

  
    "title": "Lidarr LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/Lidarr/Lidarr/develop/Logo/256.png" height="100"/></p>
  
  <h1 align="center" id="heading">Lidarr LXC </h1>
  
  [Lidarr](https://lidarr.audio/) is a music management tool designed for Usenet and BitTorrent users. It allows users to manage and organize their music collection with ease. Lidarr integrates with popular Usenet and BitTorrent clients, such as Sonarr and Radarr, to automate the downloading and organizing of music files. The software provides a web-based interface for managing and organizing music, making it easy to search and find songs, albums, and artists. Lidarr also supports metadata management, including album art, artist information, and lyrics, making it easy for users to keep their music collection organized and up-to-date. The software is designed to be easy to use and provides a simple and intuitive interface for managing and organizing music collections, making it a valuable tool for music lovers who want to keep their collection organized and up-to-date. With Lidarr, users can enjoy their music collection from anywhere, making it a powerful tool for managing and sharing music files.
  
  To create a new Proxmox VE Lidarr LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/lidarr.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  **Lidarr Interface: IP:8686**`
  },
  {
    "category": "Media - Photo",

  
    "title": "Prowlarr LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/Prowlarr/Prowlarr/develop/Logo/256.png" height="100"/></p>
  
  <h1 align="center" id="heading">Prowlarr LXC </h1>
  
  [Prowlarr](https://github.com/Prowlarr/Prowlarr) is a software tool designed to integrate with various PVR (Personal Video Recorder) apps. It is built on a popular *arr .net/ReactJS base stack and serves as an indexer manager and proxy. Prowlarr makes it easy to manage and organize TV show and movie collections, by integrating with popular PVR apps and automating the downloading and organizing of media files. The software provides a web-based interface for managing and organizing TV shows and movies, making it easy to search and find content. Prowlarr also supports metadata management, including show and movie information, making it easy for users to keep their media collection organized and up-to-date. The software is designed to be easy to use and provides a simple and intuitive interface for managing and organizing media collections, making it a valuable tool for media enthusiasts who want to keep their collection organized and up-to-date. With Prowlarr, users can enjoy their media collection from anywhere, making it a powerful tool for managing and sharing media files.
  
  To create a new Proxmox VE Prowlarr LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/prowlarr.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  **Prowlarr Interface: IP:9696**`
  },
  {
    "category": "Media - Photo",

  
    "title": "Radarr LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/Radarr/Radarr/develop/Logo/256.png" height="100"/></p>
  
  <h1 align="center" id="heading">Radarr LXC </h1>
  
  [Radarr](https://radarr.video/) is a movie management tool designed for Usenet and BitTorrent users. It allows users to manage and organize their movie collection with ease. Radarr integrates with popular Usenet and BitTorrent clients, such as Sonarr and Lidarr, to automate the downloading and organizing of movie files. The software provides a web-based interface for managing and organizing movies, making it easy to search and find titles, genres, and release dates. Radarr also supports metadata management, including movie posters and information, making it easy for users to keep their movie collection organized and up-to-date. The software is designed to be easy to use and provides a simple and intuitive interface for managing and organizing movie collections, making it a valuable tool for movie enthusiasts who want to keep their collection organized and up-to-date. With Radarr, users can enjoy their movie collection from anywhere, making it a powerful tool for managing and sharing movie files.
  
  To create a new Proxmox VE Radarr LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/radarr.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  **Radarr Interface: IP:7878**`
  },
  {
    "category": "Media - Photo",

  
    "title": "Readarr LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/Readarr/Readarr/develop/Logo/256.png" height="100"/></p>
  
  <h1 align="center" id="heading">Readarr LXC </h1>
  
  [Readarr](https://readarr.com/) is an eBook and audiobook management tool designed for Usenet and BitTorrent users. It allows users to manage and organize their eBook and audiobook collection with ease. Readarr integrates with popular Usenet and BitTorrent clients, such as Sonarr and Lidarr, to automate the downloading and organizing of eBook and audiobook files. The software provides a web-based interface for managing and organizing eBooks and audiobooks, making it easy to search and find titles, authors, and genres. Readarr also supports metadata management, including cover art and information, making it easy for users to keep their eBook and audiobook collection organized and up-to-date. The software is designed to be easy to use and provides a simple and intuitive interface for managing and organizing eBook and audiobook collections, making it a valuable tool for book and audiobook enthusiasts who want to keep their collection organized and up-to-date. With Readarr, users can enjoy their eBook and audiobook collection from anywhere, making it a powerful tool for managing and sharing book and audiobook files.
  
  To create a new Proxmox VE Radarr LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/readarr.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  **Readarr Interface: IP:8787**`
  },
  {
    "category": "Media - Photo",

  
    "title": "Sonarr LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/Sonarr/Sonarr/develop/Logo/256.png" height="100"/></p>
  
  <h1 align="center" id="heading">Sonarr LXC </h1>
  
  [Sonarr](https://sonarr.tv/) is a personal video recorder (PVR) software designed for Usenet and BitTorrent users. It allows users to manage and organize their TV show collection with ease. Sonarr integrates with popular Usenet and BitTorrent clients, such as NZBget and Transmission, to automate the downloading and organizing of TV show files. The software provides a web-based interface for managing and organizing TV shows, making it easy to search and find titles, seasons, and episodes. Sonarr also supports metadata management, including TV show posters and information, making it easy for users to keep their TV show collection organized and up-to-date. The software is designed to be easy to use and provides a simple and intuitive interface for managing and organizing TV show collections, making it a valuable tool for TV show enthusiasts who want to keep their collection organized and up-to-date. With Sonarr, users can enjoy their TV show collection from anywhere, making it a powerful tool for managing and sharing TV show files.
  
  To create a new Proxmox VE Sonarr LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/sonarr.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  **Sonarr Interface: IP:8989**`
  },
  {
    "category": "Media - Photo",

  
    "title": "Tdarr LXC",
    "content": `<p align="center"><img src="https://home.tdarr.io/static/media/logo3-min.246d6df4.png" height="100"/></p>
  
  <h1 align="center" id="heading">Tdarr LXC </h1>
  
  [Tdarr](https://tdarr.io/) is a media transcoding application designed to automate the transcode and remux management of a media library. It uses conditional-based processing to determine the required encoding and remux operations for each file in the library. The software integrates with popular media management tools, such as Sonarr and Radarr, to ensure that newly added media files are automatically processed and optimized for the user's desired playback device. Tdarr provides a web-based interface for monitoring and managing the transcoding process, and also supports real-time logging and reporting. The software is designed to be flexible and configurable, with a wide range of encoding and remux options available to users. Tdarr is an ideal solution for media enthusiasts who want to optimize their library for seamless playback on a variety of devices, while also streamlining the management and maintenance of their media library.
  
  To create a new Proxmox VE Tdarr LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/tdarr.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  **Tdarr Interface: IP:8265**`
  },
  {
    "category": "Media - Photo",

  
    "title": "Whisparr LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/Whisparr/Whisparr/develop/Logo/256.png" height="100"/></p>
  
  <h1 align="center" id="heading">Whisparr LXC </h1>
  
  [Whisparr](https://github.com/Whisparr/Whisparr) is an adult movie collection manager for Usenet and BitTorrent users.
  
  To create a new Proxmox VE Whisparr LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/whisparr.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  **Whisparr Interface: IP:6969**`
  },
  {
    "category": "Ad Blocker - DNS",

    "title": "Pi-hole LXC",
    "content": `<p align="center"><img src="https://github.com/home-assistant/brands/blob/master/core_integrations/pi_hole/icon.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Pi-hole LXC </h1>
  
  [Pi-hole](https://pi-hole.net/) is a free, open-source network-level advertisement and Internet tracker blocking application. It runs on a Raspberry Pi or other Linux-based systems and acts as a DNS sinkhole, blocking unwanted traffic before it reaches a user's device. Pi-hole can also function as a DHCP server, providing IP addresses and other network configuration information to devices on a network. The software is highly configurable and supports a wide range of customizations, such as allowing or blocking specific domains, setting up blocklists and whitelists, and customizing the appearance of the web-based interface. The main purpose of Pi-hole is to protect users' privacy and security by blocking unwanted and potentially malicious content, such as ads, trackers, and malware. It is designed to be easy to set up and use, and can be configured through a web-based interface or through a terminal-based command-line interface.
  
  To create a new Proxmox VE Pi-hole LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/pihole.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>
  
  ⚠️ **Reboot Pi-hole LXC after install**
  
  **Pi-hole Interface: IP/admin**
  
  ⚙️ **To set your password:**
  
  ~~~yaml
  pihole -a -p
  ~~~`
  },
  {
    "category": "Ad Blocker - DNS",

    "title": "Technitium DNS LXC",
    "content": `<p align="center"><img src="https://avatars.githubusercontent.com/u/12230362?s=100&v=4" height="100"/></p>
  
  <h1 align="center" id="heading"> Technitium DNS LXC </h1>

  [Technitium DNS Server](https://technitium.com/dns/) is a free, open-source and privacy-focused DNS (Domain Name System) server software for Windows, Linux, and macOS. It is designed to provide a secure, fast, and reliable DNS resolution service to its users. The server can be configured through a web-based interface, and it supports a variety of advanced features, such as automatic IP updates, IPv6 support, caching of DNS queries, and the ability to block unwanted domains. It is also designed to be highly secure, with built-in measures to prevent common types of DNS attacks and data leaks. Technitium DNS Server is aimed at providing an alternative to traditional DNS servers, which often have privacy and security concerns associated with them, and it is ideal for users who are looking for a more secure and private DNS resolution service.
  
  To create a new Proxmox VE Technitium DNS LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Technitium DNS, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/technitiumdns.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>
  
  **Technitium DNS Interface: IP:5380**`
  
  },
  {
    "category": "Ad Blocker - DNS",

    "title": "AdGuard Home LXC",
    "content": `<p align="center"><img src="https://github.com/home-assistant/brands/blob/master/core_integrations/adguard/icon.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> AdGuard Home LXC </h1>

  [AdGuard Home](https://adguard.com/en/adguard-home/overview.html) is an open-source, self-hosted network-wide ad blocker. It blocks advertisements, trackers, phishing and malware websites, and provides protection against online threats. AdGuard Home is a DNS-based solution, which means it blocks ads and malicious content at the network level, before it even reaches your device. It runs on your home network and can be easily configured and managed through a web-based interface. It provides detailed statistics and logs, allowing you to see which websites are being blocked, and why. AdGuard Home is designed to be fast, lightweight, and easy to use, making it an ideal solution for home users who want to block ads, protect their privacy, and improve the speed and security of their online experience.
  
  To create a new Proxmox VE AdGuard Home LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Manually Update AdGuard Home, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/adguard.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>
  
  As an alternative option, you can use Alpine Linux to create a AdGuard Home LXC container with faster creation time and minimal system resource usage. <br>
 
  To create a new Proxmox VE Alpine-AdGuard Home LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Manually Update Alpine-AdGuard Home, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qO - https://github.com/tteck/Proxmox/raw/main/ct/alpine-adguard.sh)"
  ~~~

  <h3 align="center" id="heading">⚡ Default Settings:  256Mib RAM - 300MiB Storage - 1vCPU ⚡</h3>

  **AdGuard Home Setup Interface: IP:3000  (After Setup use only IP)**
  
  <sub>(For the Home Assistant Integration, use port <code class="highlighter-rouge">80</code> not <code class="highlighter-rouge">3000</code>)</sub>`
  
  },
  {
    "category": "Ad Blocker - DNS",

    "title": "Blocky LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/0xERR0R/blocky/main/docs/blocky.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> Blocky LXC </h1>
  
  [Blocky](https://0xerr0r.github.io/blocky/) is a software tool designed for blocking unwanted ads and trackers on local networks. It functions as a DNS proxy and runs on the Go programming language. Blocky intercepts requests to advertisements and other unwanted content and blocks them before they reach the end user. This results in a cleaner, faster, and more secure online experience for users connected to the local network. Blocky is open-source, easy to configure and can be run on a variety of devices, making it a versatile solution for small to medium-sized local networks.
  
  To create a new Proxmox VE Blocky LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/blocky.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>
  
  
  ⚙️ **Blocky Config Path**
  
  ~~~yaml
  /opt/blocky/config.yml
  ~~~`
  },
  {
    "category": "Document - Notes",

    "title": "Paperless-ngx LXC",
    "content": `<p align="center"><img src="https://github.com/paperless-ngx/paperless-ngx/blob/main/resources/logo/web/svg/square.svg?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Paperless-ngx LXC </h1>
  
  [Paperless-ngx](https://paperless-ngx.readthedocs.io/en/latest/#) is a software tool designed for digitizing and organizing paper documents. It provides a web-based interface for scanning, uploading, and organizing paper documents, making it easier to manage, search, and access important information. Paperless-ngx uses the OCR (Optical Character Recognition) technology to extract text from scanned images and makes it searchable, thus increasing the efficiency of document management.
  
  To create a new Proxmox VE Paperless-ngx LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Paperless-ngx or Show Paperless-ngx Login Credentials, run the command below in the <b>LXC Console</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/paperless-ngx.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2048MiB RAM - 8GB Storage - 2vCPU ⚡</h3>
  
  **Paperless-ngx Interface: IP:8000**`
  
  },
  {
    "category": "Document - Notes",

    "title": "Trilium LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/zadam/trilium/master/images/app-icons/png/128x128.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Trilium LXC </h1>
  
  [Trilium](https://github.com/zadam/trilium#trilium-notes) is an open-source note-taking and personal knowledge management application. It allows users to organize and manage their notes, ideas, and information in a single place, using a hierarchical tree-like structure. Trilium offers a range of features, including rich text formatting, links, images, and attachments, making it easy to create and structure notes. The software is designed to be flexible and customizable, with a range of customization options and plugins available, including themes, export options, and more. Trilium is a self-hosted solution, and can be run on a local machine or a cloud-based server, providing users with full control over their notes and information.
  
  To create a new Proxmox VE Trilium LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Trilium, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/trilium.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>
  
  **Trilium Interface: IP:8080**`
  
  },
  {
    "category": "Document - Notes",

    "title": "Wiki.js LXC",
    "content": `<p align="center"><img src="https://static.requarks.io/logo/wikijs-butterfly.svg?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Wiki.js LXC </h1>
  
  [Wiki.js](https://js.wiki/) is a free, open-source, and modern wiki application built using Node.js. It is designed to be fast, easy to use, and flexible, with a range of features for collaboration, knowledge management, and content creation. Wiki.js supports Markdown syntax for editing pages, and includes features such as version control, page history, and access control, making it easy to manage content and collaborate with others. The software is fully customizable, with a range of themes and extensions available, and can be deployed on a local server or in the cloud, making it an ideal choice for small teams and organizations looking to create and manage a wiki. Wiki.js provides a modern, user-friendly interface, and supports a range of data sources, including local file systems, databases, and cloud storage services. 
  
  To create a new Proxmox VE Wiki.js LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Wiki.js, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/wikijs.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>
  
  **Wiki.js Interface: IP:3000**`
  },
  {
    "category": "Document - Notes",

  
    "title": "NocoDB LXC",
    "content": `<p align="center"><img src="https://github.com/tteck/Proxmox/blob/main/misc/images/nocodb.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> NocoDB LXC </h1>
  
  [NocoDB](https://www.nocodb.com/) is a document-oriented database management system. It uses the NoSQL (Not Only SQL) data model, which allows for more flexible and scalable data storage than traditional relational databases. NoCoDB stores data in JSON format, making it easier to manage and query complex data structures, and supports a range of data types, including strings, numbers, arrays, and objects. The software provides a web-based interface for managing and querying data, and includes features such as real-time data synchronization, auto-indexing, and full-text search. NoCoDB is designed to be scalable, and can be used for a range of applications, from small projects to large enterprise systems. The software is free and open-source, and is designed to be easy to use and integrate with other applications.
  
  To create a new Proxmox VE NocoDB LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update NocoDB, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/nocodb.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 4GB Storage - 1vCPU ⚡</h3>
  
  **NocoDB Interface: IP:8080/dashboard**`
  
  },
  {
    "category": "Document - Notes",
  
    "title": "Kavita LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/Kareadita/Kavita/develop/Logo/kavita.svg" height="100"/></p>
  
  <h1 align="center" id="Kavita"> Kavita LXC </h1>
  
  [Kavita](https://www.kavitareader.com/) is a fast, feature rich, cross platform reading server. Built with a focus for manga, and the goal of being a full solution for all your reading needs.
  
  To create a new Proxmox VE Kavita LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/kavita.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
  
  **Kavita Interface: IP:5000**`
  
  },
  {
    "category": "Dashboards",

    "title": "Heimdall Dashboard LXC",
    "content": `<p align="center"><img src="https://github.com/tteck/Proxmox/blob/main/misc/images/heimdall.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Heimdall Dashboard LXC </h1>
  
  [Heimdall Application Dashboard](https://camo.githubusercontent.com/bcfd4f74c93b25bea7b14eacbafd649206bf754a3d4b596329968f0ee569cf3c/68747470733a2f2f692e696d6775722e636f6d2f4d72433451704e2e676966) is a self-hosted, web-based dashboard for managing and monitoring the health of applications and servers. It allows you to keep track of the status of your systems from a single, centralized location, and receive notifications when things go wrong. With Heimdall Dashboard, you have full control over your data and can customize it to meet your specific needs. Self-hosting the dashboard gives you the flexibility to run it on your own infrastructure, making it a suitable solution for organizations that prioritize data security and privacy.
  
  To create a new Proxmox VE Heimdall Dashboard LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Heimdall Dashboard, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/heimdalldashboard.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>
  
  **Heimdall Dashboard Interface: IP:7990**`
  
  },
  {
    "category": "Dashboards",

    "title": "Homepage LXC",
    "content": `<p align="center"><img src="https://github.com/benphelps/homepage/raw/main/images/banner_light%402x.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Homepage LXC </h1>
  
  [Homepage](https://github.com/benphelps/homepage) is a self-hosted dashboard solution for centralizing and organizing data and information.
  
  To create a new Proxmox VE Homepage LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Homepage, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/homepage.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  1GB RAM - 3GB Storage - 2vCPU ⚡</h3>
  
  [Configuration](https://github.com/benphelps/homepage/wiki) (bookmarks.yaml, services.yaml, widgets.yaml) path: <code class="highlighter-rouge">/opt/homepage/config/</code>
  
  **Homepage Interface: IP:3000**`
  
  },
    {
    "category": "Dashboards",

    "title": "OliveTin",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/OliveTin/OliveTin/main/webui/OliveTinLogo.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> OliveTin </h1>

  [OliveTin](https://www.olivetin.app/) provides a secure and straightforward way to execute pre-determined shell commands through a web-based interface.
  
  To Install OliveTin, ⚠️ run the command below in the LXC console.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/misc/olivetin.sh)"
  ~~~
  
  **OliveTin Interface: IP:1337**
  
  ⚙️ **Config Path**
  
  ~~~yaml
  /etc/OliveTin/config.yaml
  ~~~`
  },
  {
    "category": "Dashboards",

    "title": "Homer LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/bastienwirtz/homer/main/public/assets/icons/logo.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> Homer LXC </h1>
  
  [Homer](https://github.com/bastienwirtz/homer#---------homer) is a simple and lightweight static homepage generator that allows you to create and manage a home page for your server. It uses a YAML configuration file to define the layout and content of your homepage, making it easy to set up and customize. The generated homepage is static, meaning it does not require any server-side processing, making it fast and efficient to serve. Homer is designed to be a flexible and low-maintenance solution for organizing and accessing your services and information from a single, centralized location.
  
  To create a new Proxmox VE Homer LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Homer, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/homer.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>

  **Homer Interface: IP:8010**
  
  ⚙️ **Config Path**
  
  ~~~yaml
  /opt/homer/assets/config.yml
  ~~~`
   
  },
  {
    "category": "Dashboards",

    "title": "Dashy LXC",
    "content": `<p align="center"><img src="https://github.com/Lissy93/dashy/raw/master/public/web-icons/dashy-logo.png" height="100"/></p>
  
  <h1 align="center" id="heading"> Dashy LXC </h1>
  
  [Dashy](https://dashy.to/) is a solution that helps you organize your self-hosted services by centralizing access to them through a single interface.
  
  To create a new Proxmox VE Dashy LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Dashy, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/dashy.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 6GB Storage - 2vCPU ⚡</h3>
  
  **Dashy Interface: IP:4000**
  
  After getting everything setup the way you want in interactive mode and saved to disk, you have to go into update configuration and rebuild application.`
  
  },
  {
    "category": "File - Code",

    "title": "File Browser",
    "content": `<p align="center"><img src="https://github.com/tteck/Proxmox/blob/main/misc/images/filebrowser.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> File Browser </h1>

  [File Browser](https://filebrowser.org/features) is a create-your-own-cloud-kind of software where you can install it on a server, direct it to a path and then access your files through a nice web interface. Many available features!
  
  To Install File Browser, ⚠️ run the command below in the LXC console.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/misc/filebrowser.sh)"
  ~~~
  
  **File Browser Interface: IP:8080**
  
  ⚙️ **Initial Login**
  
  **username** <code class="highlighter-rouge">admin</code>

  **password** <code class="highlighter-rouge">changeme</code>
  
  ⚙️ **To Update File Browser**
  
  ~~~yaml
  curl -fsSL https://raw.githubusercontent.com/filebrowser/get/master/get.sh | bash
  ~~~`
  },
  {
    "category": "File - Code",

    "title": "VS Code Server",
    "content": `<p align="center"><img src="https://user-images.githubusercontent.com/674621/71187801-14e60a80-2280-11ea-94c9-e56576f76baf.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> VS Code Server </h1>

  [VS Code Server](https://code.visualstudio.com/docs/remote/vscode-server) is a service you can run on a remote development machine, like your desktop PC or a virtual machine (VM). It allows you to securely connect to that remote machine from anywhere through a vscode.dev URL, without the requirement of SSH.
  
  To Install VS Code Server, ⚠️ run the command below in the <b>LXC console</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/misc/code-server.sh)"
  ~~~
  
  **VS Code Server Interface: IP:8680**`
  },
  {
    "category": "File - Code",

    "title": "Deluge LXC",
    "content": `<p align="center"><img src="https://dev.deluge-torrent.org/chrome/common/deluge_logo.png" height="100"/></p>
  
  <h1 align="center" id="heading"> Deluge LXC </h1>

  [Deluge](https://www.deluge-torrent.org/) is a free, open-source, lightweight BitTorrent client. It supports various platforms including Windows, Linux, and macOS, and offers features such as peer exchange, DHT, and magnet links.
  
  To create a new Proxmox VE Deluge LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/deluge.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 4GB Storage - 2vCPU ⚡</h3>

  ⚙️ **Initial Login**

  **password** <code class="highlighter-rouge">deluge</code>

  **Deluge Interface: IP:8112**`
  },
  {
    "category": "File - Code",

    "title": "Transmission LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/transmission/transmission/main/web/assets/img/logo.png" height="100"/></p>
  
  <h1 align="center" id="heading"> Transmission LXC </h1>

  [Transmission](https://transmissionbt.com/) is a free, open-source BitTorrent client known for its fast download speeds and ease of use. It supports various platforms such as Windows, Linux, and macOS and has features like web interface, peer exchange, and encrypted transfers.
  
  To create a new Proxmox VE Transmission LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/transmission.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>

  ⚙️ **Initial Login**

  **user/password** <code class="highlighter-rouge">transmission</code>

  **Transmission Interface: IP:9091/transmission**`
  },
  {
    "category": "File - Code",

    "title": "Autobrr LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/autobrr/autobrr/master/.github/images/logo.png" height="100"/></p>
  
  <h1 align="center" id="heading"> Autobrr LXC </h1>

  [Autobrr](https://autobrr.com/) is a torrent downloading tool that automates the process of downloading torrents. It is designed to be modern and user-friendly, providing users with a convenient and efficient way to download torrent files. With Autobrr, you can schedule and manage your torrent downloads, and have the ability to automatically download torrents based on certain conditions, such as time of day or availability of seeds. This can save you time and effort, allowing you to focus on other tasks while your torrents are being downloaded in the background.
  
  To create a new Proxmox VE Autobrr LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Autobrr, run the command below in the <b>LXC Console</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/autobrr.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>

  **Autobrr Interface: IP:7474**`
  },
  {
    "category": "File - Code",

    "title": "qBittorrent LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/qbittorrent/qBittorrent/master/src/icons/qbittorrent.ico" height="100"/></p>
  
  <h1 align="center" id="heading"> qBittorrent LXC </h1>

  [qBittorrent](https://www.qbittorrent.org/) offers a user-friendly interface that allows users to search for and download torrent files easily. It also supports magnet links, which allow users to start downloading files without the need for a torrent file.
  
  To create a new Proxmox VE qBittorrent LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/qbittorrent.sh)"
  ~~~

  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>  
  
  **qBittorrent Interface: IP:8090**
  
  ⚙️ **Initial Login**
  
  **username** <code class="highlighter-rouge">admin</code>
  
  **password** <code class="highlighter-rouge">adminadmin</code>`
  
  },
  {
    "category": "File - Code",

    "title": "Jackett LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/Jackett/Jackett/master/src/Jackett.Common/Content/jacket_medium.png" height="100"/></p>
  
  <h1 align="center" id="heading"> Jackett LXC </h1>

  [Jackett](https://github.com/Jackett/Jackett) supports a wide range of trackers, including popular ones like The Pirate Bay, RARBG, and Torrentz2, as well as many private trackers. It can be integrated with several BitTorrent clients, including qBittorrent, Deluge, and uTorrent, among others.
  
  To create a new Proxmox VE Jackett LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/jackett.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings: 512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>

  **Jackett Interface: IP:9117**`
  },
  {
    "category": "File - Code",

    "title": "SABnzbd LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/sabnzbd/sabnzbd/develop/icons/logo-arrow.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> SABnzbd LXC </h1>

  [SABnzbd](https://sabnzbd.org/) is a free, open-source software program for downloading binary files from Usenet newsgroups. It is designed to be easy to use, and provides a number of features to simplify the downloading process, such as automatic error detection and repair, download scheduling, and integration with other applications. SABnzbd is a binary newsreader, which means it is specifically designed for downloading binary files, such as images, music, and video, from Usenet newsgroups. With its user-friendly interface and powerful features, SABnzbd makes it easy to manage your Usenet downloads and keep your download queue organized.
  
  To create a new Proxmox VE SABnzbd LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/sabnzbd.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>

  **SABnzbd Interface: IP:7777**`
  },
  {
    "category": "File - Code",

    "title": "Webmin System Administration",
    "content": `<p align="center"><img src="https://github.com/webmin/webmin/blob/master/images/webmin-blue.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Webmin System Administration </h1>

  If you prefer to manage all aspects of your Proxmox VE LXC from a graphical interface instead of the command line interface, Webmin might be right for you.
  Benefits include automatic daily security updates, backup and restore, file manager with editor, web control panel, and preconfigured system monitoring with optional email alerts.
  
  To Install Webmin System Administration, ⚠️ run the command below in the <b>LXC console</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/misc/webmin.sh)"
  ~~~
  
  **Webmin Interface: (https)IP:10000**
  
  ⚙️ **Initial Login**
  
  **username** <code class="highlighter-rouge">root</code>
  
  **password** <code class="highlighter-rouge">root</code>
  
  ⚙️ **To Update Webmin**
  
  <code class="highlighter-rouge">Update from the Webmin UI</code>
  
  ⚙️ **To Uninstall Webmin**
  
  ~~~yaml
  bash /etc/webmin/uninstall.sh
  ~~~`
  },
  {
    "category": "File - Code",

    "title": "Syncthing LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/syncthing/syncthing/6afaa9f20c8eb9c7af5abbe2f2d90fa2571aa7ad/assets/logo-only.svg?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Syncthing LXC </h1>
  
  [Syncthing](https://syncthing.net/) is an open-source file syncing tool that allows users to keep their files in sync across multiple devices by using peer-to-peer synchronization. It doesn't rely on any central server, so all data transfers are directly between devices.
  
  To create a new Proxmox VE Syncthing LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/syncthing.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
  
  **Syncthing Interface: IP:8384**`
  
  },
  {
    "category": "File - Code",

    "title": "Daemon Sync Server LXC",
    "content": `<p align="center"><img src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fimg.informer.com%2Ficons_mac%2Fpng%2F128%2F350%2F350335.png&f=1&nofb=1" height="100"/></p>
  
  <h1 align="center" id="heading"> Daemon Sync Server LXC </h1>
  
  Sync files from app to server, share photos & videos, back up your data and stay secure inside local network.
  
  To create a new Proxmox VE Daemon Sync Server LXC, run the command below in the <b>Proxmox VE Shell</b>.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/daemonsync.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 8GB Storage - 1vCPU ⚡</h3>
  
  **Daemon Sync Server Interface: IP:8084**
  
  Search: <code class="highlighter-rouge">DAEMON Sync</code> in your favorite app store`
  },
  {
    "category": "Miscellaneous",

    "title": "Vaultwarden LXC",
    "content": `<p align="center"><img src="https://raw.githubusercontent.com/dani-garcia/vaultwarden/main/resources/vaultwarden-icon-white.svg" width="100" height="100"/></p>
  
  <h1 align="center" id="heading"> Vaultwarden LXC </h1>
  
  [Vaultwarden](https://www.vaultwarden.net/) is a self-hosted password manager which provides secure and encrypted password storage. It uses client-side encryption and provides access to passwords through a web interface and mobile apps.
  
  To create a new Proxmox VE Vaultwarden LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Vaultwarden, Web-Vault or Set the Admin Token, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/vaultwarden.sh)"
  ~~~
  ⚠️ Vaultwarden needs to be behind a proxy (Nginx Proxy Manager) to obtain HTTPS and to allow clients to connect.
  
  The script builds from source, which takes time and resources. After the build, the script will automatically set resources to Normal Settings. 
  
  <h3 align="center" id="heading">⚡ Build Settings:  4GB RAM - 6GB Storage - 4vCPU ⚡</h3>
  <h3 align="center" id="heading">⚡ Normal Settings:  512Mib RAM - 6GB Storage - 1vCPU ⚡</h3>

  As an alternative option, you can use Alpine Linux and the Vaultwarden package to create a Vaultwarden LXC container with significantly faster creation time and minimal system resource usage. <br>
  
  To create a new Proxmox VE Alpine-Vaultwarden LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Alpine-Vaultwarden, or Set the Admin Token, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qO - https://github.com/tteck/Proxmox/raw/main/ct/alpine-vaultwarden.sh)"
  ~~~

  <h3 align="center" id="heading">⚡ Default Settings:  256Mib RAM - 300MiB Storage - 1vCPU ⚡</h3>

  **Vaultwarden Interface: IP:8000**
  
  **Vaultwarden Admin Interface: IP:8000/admin**`
  
  },
  {
    "category": "Miscellaneous",

    "title": "grocy LXC",
    "content": `<p align="center"><img src="https://grocy.info/img/grocy_logo.svg" height="100"/></p>
  
  <h1 align="center" id="heading"> grocy LXC </h1>
  
  [grocy](https://grocy.info/) is a web-based self-hosted groceries & household management solution for your home. It helps you keep track of your groceries and household items, manage your shopping list, and keep track of your pantry, recipes, meal plans, and more.
  
  To create a new Proxmox VE grocy LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update grocy, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/grocy.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>
  
  **grocy Interface: IP**
  
  ⚙️ **Initial Login**
  
  **username** <code class="highlighter-rouge">admin</code>
  
  **password** <code class="highlighter-rouge">admin</code>`
  
  },
  {
    "category": "Miscellaneous",

    "title": "MagicMirror Server LXC",
  
    "content": `<p align="center"><img src="https://github.com/MichMich/MagicMirror/raw/master/.github/header.png" height="100"/></p>
  
  <h1 align="center" id="heading"> MagicMirror Server LXC </h1>
  
  [MagicMirror²](https://docs.magicmirror.builders/) is a smart mirror software that allows you to build your own personal smart mirror. It uses modular components that you can customize to display information such as the weather, news, calendar, to-do list, and more. The platform is open source, allowing for community contributions and customization.
  
  To create a new MagicMirror Server LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update MagicMirror, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/magicmirror.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings: 512MiB RAM - 3GB Storage - 1vCPU ⚡</h3>
  
  **MagicMirror Interface: IP:8080**
  
  ⚙️ **[Configuration](https://docs.magicmirror.builders/configuration/introduction.html#configuring-your-magicmirror)**
  ~~~yaml
  /opt/magicmirror/config/config.js
  ~~~`

  },
  {
    "category": "Miscellaneous",

    "title": "RSTPtoWEB LXC",
    "content": `<p align="center"><img src="https://brands.home-assistant.io/_/rtsp_to_webrtc/logo.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> RSTPtoWEB LXC </h1>
  
  [RTSPtoWeb](https://github.com/deepch/RTSPtoWeb) converts your RTSP streams to formats consumable in a web browser like MSE (Media Source Extensions), WebRTC, or HLS. It's fully native Golang without the use of FFmpeg or GStreamer
  
  To create a new Proxmox VE RSTPtoWEB LXC, run the following in the Proxmox VE Shell.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/rstptoweb.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings: 2GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  **RSTPtoWEB Interface - IP:8083**`
  
  },
  {
    "category": "Miscellaneous",

    "title": "go2rtc LXC",
    "content": `<p align="center"><img src="https://brands.home-assistant.io/_/rtsp_to_webrtc/logo.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> go2rtc LXC </h1>
  
  [go2rtc](https://github.com/AlexxIT/go2rtc) is the ultimate camera streaming application with support RTSP, WebRTC, HomeKit, FFmpeg, RTMP, etc.
  
  To create a new Proxmox VE go2rtc LXC, run the following in the Proxmox VE Shell.
  
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/go2rtc.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings: 2GB RAM - 4GB Storage - 2vCPU ⚡</h3>
  
  **go2rtc Interface - IP:1984**`
  
  },
  {
    "category": "Miscellaneous",

    "title": "Whoogle LXC",
    "content": `<p align="center"><img src="https://github.com/tteck/Proxmox/blob/main/misc/images/whoogle.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Whoogle LXC </h1>
  
  Get Google search results, but without any ads, javascript, AMP links, cookies, or IP address tracking.
  
  To create a new Proxmox VE Whoogle LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Whoogle, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/whoogle.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>

  As an alternative option, you can use Alpine Linux to create a Whoogle LXC container with faster creation time and minimal system resource usage. </b> <br> 
  In case the web UI does not appear after creation, just reboot the container.

  To create a new Proxmox VE Alpine-Whoogle LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  ~~~bash
  bash -c "$(wget -qO - https://github.com/tteck/Proxmox/raw/main/ct/alpine-whoogle.sh)"
  ~~~
  <h3 align="center" id="heading">⚡ Default Settings:  256MiB RAM - 300MiB Storage - 1vCPU ⚡</h3>

  **Whoogle Interface: IP:5000**`
  
  },
  {
    "category": "Miscellaneous",

    "title": "Shinobi NVR LXC",
    "content": `<p align="center"><img src="https://gitlab.com/uploads/-/system/project/avatar/6947723/mstile-150x150.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> Shinobi NVR LXC </h1>

  [Shinobi](https://shinobi.video/) is an open-source, self-hosted network video recording (NVR) software. It allows you to manage and monitor security cameras and record video footage. Shinobi can be run on various platforms including Linux, macOS, and Raspberry Pi, and offers features such as real-time streaming, motion detection, and email notifications.
  
  To create a new Proxmox VE Shinobi NVR LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update Shinobi, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/shinobi.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
  
  **Shinobi Interface: IP:8080**

  **Shinobi Admin Interface: IP:8080/super**
  
  ⚙️ **Initial Admin Login**
  
  **username** <code class="highlighter-rouge">admin@shinobi.video</code>
  
  **password** <code class="highlighter-rouge">admin</code>`
  
},
{
    "category": "Miscellaneous",

    "title": "MotionEye NVR LXC",
    "content": `<p align="center"><img src="https://github.com/home-assistant/brands/blob/master/core_integrations/motioneye/icon.png?raw=true" height="100"/></p>
  
  <h1 align="center" id="heading"> MotionEye NVR LXC </h1>

  MotionEye is an open-source, self-hosted network video recording (NVR) software designed to manage and monitor IP cameras. It runs on various platforms such as Linux, Raspberry Pi, and Docker, and offers features such as real-time video streaming, motion detection, and customizable camera views.
  
  To create a new Proxmox VE MotionEye NVR LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
  To Update MotionEye, run the command below in the <b>LXC Console</b>.
  ~~~bash
  bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/motioneye.sh)"
  ~~~
  
  <h3 align="center" id="heading">⚡ Default Settings:  2GB RAM - 8GB Storage - 2vCPU ⚡</h3>
  
  **MotionEye Interface: IP:8765**
  
  ⚙️ **Initial Login**
  
  **username** <code class="highlighter-rouge">admin</code>
  
  **password** <code class="highlighter-rouge">    </code>`
  
},
{
  "category": "Miscellaneous",

  "title": "Hyperion LXC",
  "content": `<p align="center"><img src="https://github.com/hyperion-project/hyperion.ng/raw/master/doc/logo_dark.png?raw=true" height="100"/></p>

<h1 align="center" id="heading"> Hyperion LXC </h1>

Hyperion is an opensource Ambient Lighting implementation. It supports many LED devices and video grabbers.

To create a new Proxmox VE Hyperion LXC, run the command below in the <b>Proxmox VE Shell</b>. <br>
To Update Hyperion, run the command below in the <b>LXC Console</b>.

~~~bash
bash -c "$(wget -qLO - https://github.com/tteck/Proxmox/raw/main/ct/hyperion.sh)"
~~~

<h3 align="center" id="heading">⚡ Default Settings:  512MiB RAM - 2GB Storage - 1vCPU ⚡</h3>

**Hyperion Interface: IP:8090**`

}
  ]
}
  
export default data;